// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:8000' | (string & {});
};

export type ApiKey = {
    readonly id: string;
    name: string;
    /**
     * Return the full API key as plain text (public.private).
     */
    readonly plain_text: string;
    readonly created_at: Date;
    readonly updated_at: Date;
};

export type AccountsApiKeysListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type AccountsGetTokenCreateError = ({
    attr: 'non_field_errors';
} & AccountsGetTokenCreateNonFieldErrorsErrorComponent) | ({
    attr: 'username';
} & AccountsGetTokenCreateUsernameErrorComponent) | ({
    attr: 'password';
} & AccountsGetTokenCreatePasswordErrorComponent);

export type AccountsGetTokenCreateErrorResponse400 = ({
    type: 'validation_error';
} & AccountsGetTokenCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AccountsGetTokenCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `no_active_account` - no_active_account
     * * `null` - null
     */
    code: 'invalid' | 'no_active_account' | 'null';
    detail: string;
};

export type AccountsGetTokenCreatePasswordErrorComponent = {
    /**
     * * `password` - password
     */
    attr: 'password';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsGetTokenCreateUsernameErrorComponent = {
    /**
     * * `username` - username
     */
    attr: 'username';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsGetTokenCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AccountsGetTokenCreateError>;
};

export type AccountsRefreshTokenCreateError = ({
    attr: 'non_field_errors';
} & AccountsRefreshTokenCreateNonFieldErrorsErrorComponent) | ({
    attr: 'token';
} & AccountsRefreshTokenCreateTokenErrorComponent);

export type AccountsRefreshTokenCreateErrorResponse400 = ({
    type: 'validation_error';
} & AccountsRefreshTokenCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AccountsRefreshTokenCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AccountsRefreshTokenCreateTokenErrorComponent = {
    /**
     * * `token` - token
     */
    attr: 'token';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsRefreshTokenCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AccountsRefreshTokenCreateError>;
};

export type AccountsReserveUsernameCreateEmailErrorComponent = {
    /**
     * * `email` - email
     */
    attr: 'email';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsReserveUsernameCreateError = ({
    attr: 'non_field_errors';
} & AccountsReserveUsernameCreateNonFieldErrorsErrorComponent) | ({
    attr: 'username';
} & AccountsReserveUsernameCreateUsernameErrorComponent) | ({
    attr: 'email';
} & AccountsReserveUsernameCreateEmailErrorComponent) | ({
    attr: 'recaptcha_token';
} & AccountsReserveUsernameCreateRecaptchaTokenErrorComponent);

export type AccountsReserveUsernameCreateErrorResponse400 = ({
    type: 'validation_error';
} & AccountsReserveUsernameCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AccountsReserveUsernameCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AccountsReserveUsernameCreateRecaptchaTokenErrorComponent = {
    /**
     * * `recaptcha_token` - recaptcha_token
     */
    attr: 'recaptcha_token';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsReserveUsernameCreateUsernameErrorComponent = {
    /**
     * * `username` - username
     */
    attr: 'username';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsReserveUsernameCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AccountsReserveUsernameCreateError>;
};

export type AccountsResetPasswordConfirmCreateConfirmPasswordErrorComponent = {
    /**
     * * `confirm_password` - confirm_password
     */
    attr: 'confirm_password';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `min_length` - min_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'min_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsResetPasswordConfirmCreateError = ({
    attr: 'non_field_errors';
} & AccountsResetPasswordConfirmCreateNonFieldErrorsErrorComponent) | ({
    attr: 'password';
} & AccountsResetPasswordConfirmCreatePasswordErrorComponent) | ({
    attr: 'confirm_password';
} & AccountsResetPasswordConfirmCreateConfirmPasswordErrorComponent) | ({
    attr: 'token';
} & AccountsResetPasswordConfirmCreateTokenErrorComponent);

export type AccountsResetPasswordConfirmCreateErrorResponse400 = ({
    type: 'validation_error';
} & AccountsResetPasswordConfirmCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AccountsResetPasswordConfirmCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `invalid_link` - invalid_link
     * * `null` - null
     * * `password_mismatch` - password_mismatch
     */
    code: 'invalid' | 'invalid_link' | 'null' | 'password_mismatch';
    detail: string;
};

export type AccountsResetPasswordConfirmCreatePasswordErrorComponent = {
    /**
     * * `password` - password
     */
    attr: 'password';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `min_length` - min_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'min_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsResetPasswordConfirmCreateTokenErrorComponent = {
    /**
     * * `token` - token
     */
    attr: 'token';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AccountsResetPasswordConfirmCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AccountsResetPasswordConfirmCreateError>;
};

export type AccountsResetPasswordCreateEmailErrorComponent = {
    /**
     * * `email` - email
     */
    attr: 'email';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AccountsResetPasswordCreateError = ({
    attr: 'non_field_errors';
} & AccountsResetPasswordCreateNonFieldErrorsErrorComponent) | ({
    attr: 'email';
} & AccountsResetPasswordCreateEmailErrorComponent);

export type AccountsResetPasswordCreateErrorResponse400 = ({
    type: 'validation_error';
} & AccountsResetPasswordCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AccountsResetPasswordCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AccountsResetPasswordCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AccountsResetPasswordCreateError>;
};

/**
 * Serializer for a single Amazon product detail.
 */
export type AmazonProduct = {
    productDescription?: string;
    asin: string;
    countReview?: number | null;
    imgUrl: string;
    price?: number | null;
    retailPrice?: number | null;
    productRating?: string | null;
    prime: boolean;
    dpUrl: string;
    series?: string | null;
    deliveryMessage?: string | null;
    variations?: Array<{
        [key: string]: unknown;
    }>;
    productDetails?: Array<{
        [key: string]: unknown;
    }>;
    salesVolume?: string | null;
    manufacturer?: string | null;
    secondaryOffer?: number | null;
};

/**
 * Serializer for a single Amazon product detail.
 */
export type AmazonProductRequest = {
    productDescription?: string;
    asin: string;
    countReview?: number | null;
    imgUrl: string;
    price?: number | null;
    retailPrice?: number | null;
    productRating?: string | null;
    prime: boolean;
    dpUrl: string;
    series?: string | null;
    deliveryMessage?: string | null;
    variations?: Array<{
        [key: string]: unknown;
    }>;
    productDetails?: Array<{
        [key: string]: unknown;
    }>;
    salesVolume?: string | null;
    manufacturer?: string | null;
    secondaryOffer?: number | null;
};

/**
 * Serializer for searching Amazon products.
 */
export type AmazonSearch = {
    readonly search_results: Array<unknown>;
};

export type Annotation = {
    readonly id: string;
    title: string;
    description: string;
    meta: AnnotationMeta;
    readonly user: string;
    readonly created_at: Date;
    readonly updated_at: Date;
    is_deleted?: boolean;
    kind: KindEnum;
    /**
     * Time in seconds
     */
    starts_at: number;
    /**
     * Time in seconds
     */
    ends_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
};

export type AnnotationMeta = {
    thumbnail?: string;
    location?: Location | null;
    product?: AmazonProduct;
    url?: string;
};

export type AnnotationMetaRequest = {
    thumbnail?: string;
    location?: LocationRequest | null;
    product?: AmazonProductRequest;
    url?: string;
};

export type AnnotationMetrics = {
    impressions?: number;
    expands?: number;
    clickthroughs?: number;
};

export type AnnotationRequest = {
    title: string;
    description: string;
    meta: AnnotationMetaRequest;
    is_deleted?: boolean;
    kind: KindEnum;
    /**
     * Time in seconds
     */
    starts_at: number;
    /**
     * Time in seconds
     */
    ends_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
};

export type AnnotationsCreateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateEndsAtErrorComponent = {
    /**
     * * `ends_at` - ends_at
     */
    attr: 'ends_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateError = ({
    attr: 'non_field_errors';
} & AnnotationsCreateNonFieldErrorsErrorComponent) | ({
    attr: 'title';
} & AnnotationsCreateTitleErrorComponent) | ({
    attr: 'description';
} & AnnotationsCreateDescriptionErrorComponent) | ({
    attr: 'meta.non_field_errors';
} & AnnotationsCreateMetaNonFieldErrorsErrorComponent) | ({
    attr: 'meta.thumbnail';
} & AnnotationsCreateMetaThumbnailErrorComponent) | ({
    attr: 'meta.location.non_field_errors';
} & AnnotationsCreateMetaLocationNonFieldErrorsErrorComponent) | ({
    attr: 'meta.location.latitude';
} & AnnotationsCreateMetaLocationLatitudeErrorComponent) | ({
    attr: 'meta.location.longitude';
} & AnnotationsCreateMetaLocationLongitudeErrorComponent) | ({
    attr: 'meta.location.url';
} & AnnotationsCreateMetaLocationUrlErrorComponent) | ({
    attr: 'meta.product.non_field_errors';
} & AnnotationsCreateMetaProductNonFieldErrorsErrorComponent) | ({
    attr: 'meta.product.productDescription';
} & AnnotationsCreateMetaProductProductDescriptionErrorComponent) | ({
    attr: 'meta.product.asin';
} & AnnotationsCreateMetaProductAsinErrorComponent) | ({
    attr: 'meta.product.countReview';
} & AnnotationsCreateMetaProductCountReviewErrorComponent) | ({
    attr: 'meta.product.imgUrl';
} & AnnotationsCreateMetaProductImgUrlErrorComponent) | ({
    attr: 'meta.product.price';
} & AnnotationsCreateMetaProductPriceErrorComponent) | ({
    attr: 'meta.product.retailPrice';
} & AnnotationsCreateMetaProductRetailPriceErrorComponent) | ({
    attr: 'meta.product.productRating';
} & AnnotationsCreateMetaProductProductRatingErrorComponent) | ({
    attr: 'meta.product.prime';
} & AnnotationsCreateMetaProductPrimeErrorComponent) | ({
    attr: 'meta.product.dpUrl';
} & AnnotationsCreateMetaProductDpUrlErrorComponent) | ({
    attr: 'meta.product.series';
} & AnnotationsCreateMetaProductSeriesErrorComponent) | ({
    attr: 'meta.product.deliveryMessage';
} & AnnotationsCreateMetaProductDeliveryMessageErrorComponent) | ({
    attr: 'meta.product.variations';
} & AnnotationsCreateMetaProductVariationsErrorComponent) | ({
    attr: 'meta.product.variations.INDEX';
} & AnnotationsCreateMetaProductVariationsIndexErrorComponent) | ({
    attr: 'meta.product.variations.INDEX.KEY';
} & AnnotationsCreateMetaProductVariationsIndexkeyErrorComponent) | ({
    attr: 'meta.product.productDetails';
} & AnnotationsCreateMetaProductProductDetailsErrorComponent) | ({
    attr: 'meta.product.productDetails.INDEX';
} & AnnotationsCreateMetaProductProductDetailsIndexErrorComponent) | ({
    attr: 'meta.product.productDetails.INDEX.KEY';
} & AnnotationsCreateMetaProductProductDetailsIndexkeyErrorComponent) | ({
    attr: 'meta.product.salesVolume';
} & AnnotationsCreateMetaProductSalesVolumeErrorComponent) | ({
    attr: 'meta.product.manufacturer';
} & AnnotationsCreateMetaProductManufacturerErrorComponent) | ({
    attr: 'meta.product.secondaryOffer';
} & AnnotationsCreateMetaProductSecondaryOfferErrorComponent) | ({
    attr: 'meta.url';
} & AnnotationsCreateMetaUrlErrorComponent) | ({
    attr: 'is_deleted';
} & AnnotationsCreateIsDeletedErrorComponent) | ({
    attr: 'kind';
} & AnnotationsCreateKindErrorComponent) | ({
    attr: 'starts_at';
} & AnnotationsCreateStartsAtErrorComponent) | ({
    attr: 'ends_at';
} & AnnotationsCreateEndsAtErrorComponent) | ({
    attr: 'is_sponsored';
} & AnnotationsCreateIsSponsoredErrorComponent) | ({
    attr: 'channel';
} & AnnotationsCreateChannelErrorComponent) | ({
    attr: 'video';
} & AnnotationsCreateVideoErrorComponent);

export type AnnotationsCreateErrorResponse400 = ({
    type: 'validation_error';
} & AnnotationsCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AnnotationsCreateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsCreateIsSponsoredErrorComponent = {
    /**
     * * `is_sponsored` - is_sponsored
     */
    attr: 'is_sponsored';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsCreateKindErrorComponent = {
    /**
     * * `kind` - kind
     */
    attr: 'kind';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateMetaLocationLatitudeErrorComponent = {
    /**
     * * `meta.location.latitude` - meta.location.latitude
     */
    attr: 'meta.location.latitude';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsCreateMetaLocationLongitudeErrorComponent = {
    /**
     * * `meta.location.longitude` - meta.location.longitude
     */
    attr: 'meta.location.longitude';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsCreateMetaLocationNonFieldErrorsErrorComponent = {
    /**
     * * `meta.location.non_field_errors` - meta.location.non_field_errors
     */
    attr: 'meta.location.non_field_errors';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type AnnotationsCreateMetaLocationUrlErrorComponent = {
    /**
     * * `meta.location.url` - meta.location.url
     */
    attr: 'meta.location.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaNonFieldErrorsErrorComponent = {
    /**
     * * `meta.non_field_errors` - meta.non_field_errors
     */
    attr: 'meta.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateMetaProductAsinErrorComponent = {
    /**
     * * `meta.product.asin` - meta.product.asin
     */
    attr: 'meta.product.asin';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductCountReviewErrorComponent = {
    /**
     * * `meta.product.countReview` - meta.product.countReview
     */
    attr: 'meta.product.countReview';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsCreateMetaProductDeliveryMessageErrorComponent = {
    /**
     * * `meta.product.deliveryMessage` - meta.product.deliveryMessage
     */
    attr: 'meta.product.deliveryMessage';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductDpUrlErrorComponent = {
    /**
     * * `meta.product.dpUrl` - meta.product.dpUrl
     */
    attr: 'meta.product.dpUrl';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductImgUrlErrorComponent = {
    /**
     * * `meta.product.imgUrl` - meta.product.imgUrl
     */
    attr: 'meta.product.imgUrl';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductManufacturerErrorComponent = {
    /**
     * * `meta.product.manufacturer` - meta.product.manufacturer
     */
    attr: 'meta.product.manufacturer';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductNonFieldErrorsErrorComponent = {
    /**
     * * `meta.product.non_field_errors` - meta.product.non_field_errors
     */
    attr: 'meta.product.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsCreateMetaProductPriceErrorComponent = {
    /**
     * * `meta.product.price` - meta.product.price
     */
    attr: 'meta.product.price';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsCreateMetaProductPrimeErrorComponent = {
    /**
     * * `meta.product.prime` - meta.product.prime
     */
    attr: 'meta.product.prime';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateMetaProductProductDescriptionErrorComponent = {
    /**
     * * `meta.product.productDescription` - meta.product.productDescription
     */
    attr: 'meta.product.productDescription';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductProductDetailsErrorComponent = {
    /**
     * * `meta.product.productDetails` - meta.product.productDetails
     */
    attr: 'meta.product.productDetails';
    /**
     * * `not_a_list` - not_a_list
     * * `null` - null
     */
    code: 'not_a_list' | 'null';
    detail: string;
};

export type AnnotationsCreateMetaProductProductDetailsIndexErrorComponent = {
    /**
     * * `meta.product.productDetails.INDEX` - meta.product.productDetails.INDEX
     */
    attr: 'meta.product.productDetails.INDEX';
    /**
     * * `not_a_dict` - not_a_dict
     * * `null` - null
     * * `required` - required
     */
    code: 'not_a_dict' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateMetaProductProductDetailsIndexkeyErrorComponent = {
    /**
     * * `meta.product.productDetails.INDEX.KEY` - meta.product.productDetails.INDEX.KEY
     */
    attr: 'meta.product.productDetails.INDEX.KEY';
    /**
     * * `required` - required
     */
    code: 'required';
    detail: string;
};

export type AnnotationsCreateMetaProductProductRatingErrorComponent = {
    /**
     * * `meta.product.productRating` - meta.product.productRating
     */
    attr: 'meta.product.productRating';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductRetailPriceErrorComponent = {
    /**
     * * `meta.product.retailPrice` - meta.product.retailPrice
     */
    attr: 'meta.product.retailPrice';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsCreateMetaProductSalesVolumeErrorComponent = {
    /**
     * * `meta.product.salesVolume` - meta.product.salesVolume
     */
    attr: 'meta.product.salesVolume';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductSecondaryOfferErrorComponent = {
    /**
     * * `meta.product.secondaryOffer` - meta.product.secondaryOffer
     */
    attr: 'meta.product.secondaryOffer';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsCreateMetaProductSeriesErrorComponent = {
    /**
     * * `meta.product.series` - meta.product.series
     */
    attr: 'meta.product.series';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaProductVariationsErrorComponent = {
    /**
     * * `meta.product.variations` - meta.product.variations
     */
    attr: 'meta.product.variations';
    /**
     * * `not_a_list` - not_a_list
     * * `null` - null
     */
    code: 'not_a_list' | 'null';
    detail: string;
};

export type AnnotationsCreateMetaProductVariationsIndexErrorComponent = {
    /**
     * * `meta.product.variations.INDEX` - meta.product.variations.INDEX
     */
    attr: 'meta.product.variations.INDEX';
    /**
     * * `not_a_dict` - not_a_dict
     * * `null` - null
     * * `required` - required
     */
    code: 'not_a_dict' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateMetaProductVariationsIndexkeyErrorComponent = {
    /**
     * * `meta.product.variations.INDEX.KEY` - meta.product.variations.INDEX.KEY
     */
    attr: 'meta.product.variations.INDEX.KEY';
    /**
     * * `required` - required
     */
    code: 'required';
    detail: string;
};

export type AnnotationsCreateMetaThumbnailErrorComponent = {
    /**
     * * `meta.thumbnail` - meta.thumbnail
     */
    attr: 'meta.thumbnail';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateMetaUrlErrorComponent = {
    /**
     * * `meta.url` - meta.url
     */
    attr: 'meta.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsCreateStartsAtErrorComponent = {
    /**
     * * `starts_at` - starts_at
     */
    attr: 'starts_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type AnnotationsCreateTitleErrorComponent = {
    /**
     * * `title` - title
     */
    attr: 'title';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AnnotationsCreateError>;
};

export type AnnotationsCreateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type AnnotationsDestroyErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type AnnotationsListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type AnnotationsPartialUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateEndsAtErrorComponent = {
    /**
     * * `ends_at` - ends_at
     */
    attr: 'ends_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateError = ({
    attr: 'non_field_errors';
} & AnnotationsPartialUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'title';
} & AnnotationsPartialUpdateTitleErrorComponent) | ({
    attr: 'description';
} & AnnotationsPartialUpdateDescriptionErrorComponent) | ({
    attr: 'meta.non_field_errors';
} & AnnotationsPartialUpdateMetaNonFieldErrorsErrorComponent) | ({
    attr: 'meta.thumbnail';
} & AnnotationsPartialUpdateMetaThumbnailErrorComponent) | ({
    attr: 'meta.location.non_field_errors';
} & AnnotationsPartialUpdateMetaLocationNonFieldErrorsErrorComponent) | ({
    attr: 'meta.location.latitude';
} & AnnotationsPartialUpdateMetaLocationLatitudeErrorComponent) | ({
    attr: 'meta.location.longitude';
} & AnnotationsPartialUpdateMetaLocationLongitudeErrorComponent) | ({
    attr: 'meta.location.url';
} & AnnotationsPartialUpdateMetaLocationUrlErrorComponent) | ({
    attr: 'meta.product.non_field_errors';
} & AnnotationsPartialUpdateMetaProductNonFieldErrorsErrorComponent) | ({
    attr: 'meta.product.productDescription';
} & AnnotationsPartialUpdateMetaProductProductDescriptionErrorComponent) | ({
    attr: 'meta.product.asin';
} & AnnotationsPartialUpdateMetaProductAsinErrorComponent) | ({
    attr: 'meta.product.countReview';
} & AnnotationsPartialUpdateMetaProductCountReviewErrorComponent) | ({
    attr: 'meta.product.imgUrl';
} & AnnotationsPartialUpdateMetaProductImgUrlErrorComponent) | ({
    attr: 'meta.product.price';
} & AnnotationsPartialUpdateMetaProductPriceErrorComponent) | ({
    attr: 'meta.product.retailPrice';
} & AnnotationsPartialUpdateMetaProductRetailPriceErrorComponent) | ({
    attr: 'meta.product.productRating';
} & AnnotationsPartialUpdateMetaProductProductRatingErrorComponent) | ({
    attr: 'meta.product.prime';
} & AnnotationsPartialUpdateMetaProductPrimeErrorComponent) | ({
    attr: 'meta.product.dpUrl';
} & AnnotationsPartialUpdateMetaProductDpUrlErrorComponent) | ({
    attr: 'meta.product.series';
} & AnnotationsPartialUpdateMetaProductSeriesErrorComponent) | ({
    attr: 'meta.product.deliveryMessage';
} & AnnotationsPartialUpdateMetaProductDeliveryMessageErrorComponent) | ({
    attr: 'meta.product.variations';
} & AnnotationsPartialUpdateMetaProductVariationsErrorComponent) | ({
    attr: 'meta.product.variations.INDEX';
} & AnnotationsPartialUpdateMetaProductVariationsIndexErrorComponent) | ({
    attr: 'meta.product.variations.INDEX.KEY';
} & AnnotationsPartialUpdateMetaProductVariationsIndexkeyErrorComponent) | ({
    attr: 'meta.product.productDetails';
} & AnnotationsPartialUpdateMetaProductProductDetailsErrorComponent) | ({
    attr: 'meta.product.productDetails.INDEX';
} & AnnotationsPartialUpdateMetaProductProductDetailsIndexErrorComponent) | ({
    attr: 'meta.product.productDetails.INDEX.KEY';
} & AnnotationsPartialUpdateMetaProductProductDetailsIndexkeyErrorComponent) | ({
    attr: 'meta.product.salesVolume';
} & AnnotationsPartialUpdateMetaProductSalesVolumeErrorComponent) | ({
    attr: 'meta.product.manufacturer';
} & AnnotationsPartialUpdateMetaProductManufacturerErrorComponent) | ({
    attr: 'meta.product.secondaryOffer';
} & AnnotationsPartialUpdateMetaProductSecondaryOfferErrorComponent) | ({
    attr: 'meta.url';
} & AnnotationsPartialUpdateMetaUrlErrorComponent) | ({
    attr: 'is_deleted';
} & AnnotationsPartialUpdateIsDeletedErrorComponent) | ({
    attr: 'kind';
} & AnnotationsPartialUpdateKindErrorComponent) | ({
    attr: 'starts_at';
} & AnnotationsPartialUpdateStartsAtErrorComponent) | ({
    attr: 'ends_at';
} & AnnotationsPartialUpdateEndsAtErrorComponent) | ({
    attr: 'is_sponsored';
} & AnnotationsPartialUpdateIsSponsoredErrorComponent) | ({
    attr: 'channel';
} & AnnotationsPartialUpdateChannelErrorComponent) | ({
    attr: 'video';
} & AnnotationsPartialUpdateVideoErrorComponent);

export type AnnotationsPartialUpdateErrorResponse400 = ({
    type: 'validation_error';
} & AnnotationsPartialUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AnnotationsPartialUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsPartialUpdateIsSponsoredErrorComponent = {
    /**
     * * `is_sponsored` - is_sponsored
     */
    attr: 'is_sponsored';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsPartialUpdateKindErrorComponent = {
    /**
     * * `kind` - kind
     */
    attr: 'kind';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaLocationLatitudeErrorComponent = {
    /**
     * * `meta.location.latitude` - meta.location.latitude
     */
    attr: 'meta.location.latitude';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsPartialUpdateMetaLocationLongitudeErrorComponent = {
    /**
     * * `meta.location.longitude` - meta.location.longitude
     */
    attr: 'meta.location.longitude';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsPartialUpdateMetaLocationNonFieldErrorsErrorComponent = {
    /**
     * * `meta.location.non_field_errors` - meta.location.non_field_errors
     */
    attr: 'meta.location.non_field_errors';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type AnnotationsPartialUpdateMetaLocationUrlErrorComponent = {
    /**
     * * `meta.location.url` - meta.location.url
     */
    attr: 'meta.location.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaNonFieldErrorsErrorComponent = {
    /**
     * * `meta.non_field_errors` - meta.non_field_errors
     */
    attr: 'meta.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductAsinErrorComponent = {
    /**
     * * `meta.product.asin` - meta.product.asin
     */
    attr: 'meta.product.asin';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductCountReviewErrorComponent = {
    /**
     * * `meta.product.countReview` - meta.product.countReview
     */
    attr: 'meta.product.countReview';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductDeliveryMessageErrorComponent = {
    /**
     * * `meta.product.deliveryMessage` - meta.product.deliveryMessage
     */
    attr: 'meta.product.deliveryMessage';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductDpUrlErrorComponent = {
    /**
     * * `meta.product.dpUrl` - meta.product.dpUrl
     */
    attr: 'meta.product.dpUrl';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductImgUrlErrorComponent = {
    /**
     * * `meta.product.imgUrl` - meta.product.imgUrl
     */
    attr: 'meta.product.imgUrl';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductManufacturerErrorComponent = {
    /**
     * * `meta.product.manufacturer` - meta.product.manufacturer
     */
    attr: 'meta.product.manufacturer';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductNonFieldErrorsErrorComponent = {
    /**
     * * `meta.product.non_field_errors` - meta.product.non_field_errors
     */
    attr: 'meta.product.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductPriceErrorComponent = {
    /**
     * * `meta.product.price` - meta.product.price
     */
    attr: 'meta.product.price';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductPrimeErrorComponent = {
    /**
     * * `meta.product.prime` - meta.product.prime
     */
    attr: 'meta.product.prime';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductProductDescriptionErrorComponent = {
    /**
     * * `meta.product.productDescription` - meta.product.productDescription
     */
    attr: 'meta.product.productDescription';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductProductDetailsErrorComponent = {
    /**
     * * `meta.product.productDetails` - meta.product.productDetails
     */
    attr: 'meta.product.productDetails';
    /**
     * * `not_a_list` - not_a_list
     * * `null` - null
     */
    code: 'not_a_list' | 'null';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductProductDetailsIndexErrorComponent = {
    /**
     * * `meta.product.productDetails.INDEX` - meta.product.productDetails.INDEX
     */
    attr: 'meta.product.productDetails.INDEX';
    /**
     * * `not_a_dict` - not_a_dict
     * * `null` - null
     * * `required` - required
     */
    code: 'not_a_dict' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductProductDetailsIndexkeyErrorComponent = {
    /**
     * * `meta.product.productDetails.INDEX.KEY` - meta.product.productDetails.INDEX.KEY
     */
    attr: 'meta.product.productDetails.INDEX.KEY';
    /**
     * * `required` - required
     */
    code: 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductProductRatingErrorComponent = {
    /**
     * * `meta.product.productRating` - meta.product.productRating
     */
    attr: 'meta.product.productRating';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductRetailPriceErrorComponent = {
    /**
     * * `meta.product.retailPrice` - meta.product.retailPrice
     */
    attr: 'meta.product.retailPrice';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductSalesVolumeErrorComponent = {
    /**
     * * `meta.product.salesVolume` - meta.product.salesVolume
     */
    attr: 'meta.product.salesVolume';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductSecondaryOfferErrorComponent = {
    /**
     * * `meta.product.secondaryOffer` - meta.product.secondaryOffer
     */
    attr: 'meta.product.secondaryOffer';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductSeriesErrorComponent = {
    /**
     * * `meta.product.series` - meta.product.series
     */
    attr: 'meta.product.series';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductVariationsErrorComponent = {
    /**
     * * `meta.product.variations` - meta.product.variations
     */
    attr: 'meta.product.variations';
    /**
     * * `not_a_list` - not_a_list
     * * `null` - null
     */
    code: 'not_a_list' | 'null';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductVariationsIndexErrorComponent = {
    /**
     * * `meta.product.variations.INDEX` - meta.product.variations.INDEX
     */
    attr: 'meta.product.variations.INDEX';
    /**
     * * `not_a_dict` - not_a_dict
     * * `null` - null
     * * `required` - required
     */
    code: 'not_a_dict' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaProductVariationsIndexkeyErrorComponent = {
    /**
     * * `meta.product.variations.INDEX.KEY` - meta.product.variations.INDEX.KEY
     */
    attr: 'meta.product.variations.INDEX.KEY';
    /**
     * * `required` - required
     */
    code: 'required';
    detail: string;
};

export type AnnotationsPartialUpdateMetaThumbnailErrorComponent = {
    /**
     * * `meta.thumbnail` - meta.thumbnail
     */
    attr: 'meta.thumbnail';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateMetaUrlErrorComponent = {
    /**
     * * `meta.url` - meta.url
     */
    attr: 'meta.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsPartialUpdateStartsAtErrorComponent = {
    /**
     * * `starts_at` - starts_at
     */
    attr: 'starts_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type AnnotationsPartialUpdateTitleErrorComponent = {
    /**
     * * `title` - title
     */
    attr: 'title';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsPartialUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AnnotationsPartialUpdateError>;
};

export type AnnotationsPartialUpdateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type AnnotationsRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type AnnotationsUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateEndsAtErrorComponent = {
    /**
     * * `ends_at` - ends_at
     */
    attr: 'ends_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateError = ({
    attr: 'non_field_errors';
} & AnnotationsUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'title';
} & AnnotationsUpdateTitleErrorComponent) | ({
    attr: 'description';
} & AnnotationsUpdateDescriptionErrorComponent) | ({
    attr: 'meta.non_field_errors';
} & AnnotationsUpdateMetaNonFieldErrorsErrorComponent) | ({
    attr: 'meta.thumbnail';
} & AnnotationsUpdateMetaThumbnailErrorComponent) | ({
    attr: 'meta.location.non_field_errors';
} & AnnotationsUpdateMetaLocationNonFieldErrorsErrorComponent) | ({
    attr: 'meta.location.latitude';
} & AnnotationsUpdateMetaLocationLatitudeErrorComponent) | ({
    attr: 'meta.location.longitude';
} & AnnotationsUpdateMetaLocationLongitudeErrorComponent) | ({
    attr: 'meta.location.url';
} & AnnotationsUpdateMetaLocationUrlErrorComponent) | ({
    attr: 'meta.product.non_field_errors';
} & AnnotationsUpdateMetaProductNonFieldErrorsErrorComponent) | ({
    attr: 'meta.product.productDescription';
} & AnnotationsUpdateMetaProductProductDescriptionErrorComponent) | ({
    attr: 'meta.product.asin';
} & AnnotationsUpdateMetaProductAsinErrorComponent) | ({
    attr: 'meta.product.countReview';
} & AnnotationsUpdateMetaProductCountReviewErrorComponent) | ({
    attr: 'meta.product.imgUrl';
} & AnnotationsUpdateMetaProductImgUrlErrorComponent) | ({
    attr: 'meta.product.price';
} & AnnotationsUpdateMetaProductPriceErrorComponent) | ({
    attr: 'meta.product.retailPrice';
} & AnnotationsUpdateMetaProductRetailPriceErrorComponent) | ({
    attr: 'meta.product.productRating';
} & AnnotationsUpdateMetaProductProductRatingErrorComponent) | ({
    attr: 'meta.product.prime';
} & AnnotationsUpdateMetaProductPrimeErrorComponent) | ({
    attr: 'meta.product.dpUrl';
} & AnnotationsUpdateMetaProductDpUrlErrorComponent) | ({
    attr: 'meta.product.series';
} & AnnotationsUpdateMetaProductSeriesErrorComponent) | ({
    attr: 'meta.product.deliveryMessage';
} & AnnotationsUpdateMetaProductDeliveryMessageErrorComponent) | ({
    attr: 'meta.product.variations';
} & AnnotationsUpdateMetaProductVariationsErrorComponent) | ({
    attr: 'meta.product.variations.INDEX';
} & AnnotationsUpdateMetaProductVariationsIndexErrorComponent) | ({
    attr: 'meta.product.variations.INDEX.KEY';
} & AnnotationsUpdateMetaProductVariationsIndexkeyErrorComponent) | ({
    attr: 'meta.product.productDetails';
} & AnnotationsUpdateMetaProductProductDetailsErrorComponent) | ({
    attr: 'meta.product.productDetails.INDEX';
} & AnnotationsUpdateMetaProductProductDetailsIndexErrorComponent) | ({
    attr: 'meta.product.productDetails.INDEX.KEY';
} & AnnotationsUpdateMetaProductProductDetailsIndexkeyErrorComponent) | ({
    attr: 'meta.product.salesVolume';
} & AnnotationsUpdateMetaProductSalesVolumeErrorComponent) | ({
    attr: 'meta.product.manufacturer';
} & AnnotationsUpdateMetaProductManufacturerErrorComponent) | ({
    attr: 'meta.product.secondaryOffer';
} & AnnotationsUpdateMetaProductSecondaryOfferErrorComponent) | ({
    attr: 'meta.url';
} & AnnotationsUpdateMetaUrlErrorComponent) | ({
    attr: 'is_deleted';
} & AnnotationsUpdateIsDeletedErrorComponent) | ({
    attr: 'kind';
} & AnnotationsUpdateKindErrorComponent) | ({
    attr: 'starts_at';
} & AnnotationsUpdateStartsAtErrorComponent) | ({
    attr: 'ends_at';
} & AnnotationsUpdateEndsAtErrorComponent) | ({
    attr: 'is_sponsored';
} & AnnotationsUpdateIsSponsoredErrorComponent) | ({
    attr: 'channel';
} & AnnotationsUpdateChannelErrorComponent) | ({
    attr: 'video';
} & AnnotationsUpdateVideoErrorComponent);

export type AnnotationsUpdateErrorResponse400 = ({
    type: 'validation_error';
} & AnnotationsUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AnnotationsUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsUpdateIsSponsoredErrorComponent = {
    /**
     * * `is_sponsored` - is_sponsored
     */
    attr: 'is_sponsored';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsUpdateKindErrorComponent = {
    /**
     * * `kind` - kind
     */
    attr: 'kind';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateMetaLocationLatitudeErrorComponent = {
    /**
     * * `meta.location.latitude` - meta.location.latitude
     */
    attr: 'meta.location.latitude';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsUpdateMetaLocationLongitudeErrorComponent = {
    /**
     * * `meta.location.longitude` - meta.location.longitude
     */
    attr: 'meta.location.longitude';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsUpdateMetaLocationNonFieldErrorsErrorComponent = {
    /**
     * * `meta.location.non_field_errors` - meta.location.non_field_errors
     */
    attr: 'meta.location.non_field_errors';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type AnnotationsUpdateMetaLocationUrlErrorComponent = {
    /**
     * * `meta.location.url` - meta.location.url
     */
    attr: 'meta.location.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaNonFieldErrorsErrorComponent = {
    /**
     * * `meta.non_field_errors` - meta.non_field_errors
     */
    attr: 'meta.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateMetaProductAsinErrorComponent = {
    /**
     * * `meta.product.asin` - meta.product.asin
     */
    attr: 'meta.product.asin';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductCountReviewErrorComponent = {
    /**
     * * `meta.product.countReview` - meta.product.countReview
     */
    attr: 'meta.product.countReview';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsUpdateMetaProductDeliveryMessageErrorComponent = {
    /**
     * * `meta.product.deliveryMessage` - meta.product.deliveryMessage
     */
    attr: 'meta.product.deliveryMessage';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductDpUrlErrorComponent = {
    /**
     * * `meta.product.dpUrl` - meta.product.dpUrl
     */
    attr: 'meta.product.dpUrl';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductImgUrlErrorComponent = {
    /**
     * * `meta.product.imgUrl` - meta.product.imgUrl
     */
    attr: 'meta.product.imgUrl';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductManufacturerErrorComponent = {
    /**
     * * `meta.product.manufacturer` - meta.product.manufacturer
     */
    attr: 'meta.product.manufacturer';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductNonFieldErrorsErrorComponent = {
    /**
     * * `meta.product.non_field_errors` - meta.product.non_field_errors
     */
    attr: 'meta.product.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsUpdateMetaProductPriceErrorComponent = {
    /**
     * * `meta.product.price` - meta.product.price
     */
    attr: 'meta.product.price';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsUpdateMetaProductPrimeErrorComponent = {
    /**
     * * `meta.product.prime` - meta.product.prime
     */
    attr: 'meta.product.prime';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateMetaProductProductDescriptionErrorComponent = {
    /**
     * * `meta.product.productDescription` - meta.product.productDescription
     */
    attr: 'meta.product.productDescription';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductProductDetailsErrorComponent = {
    /**
     * * `meta.product.productDetails` - meta.product.productDetails
     */
    attr: 'meta.product.productDetails';
    /**
     * * `not_a_list` - not_a_list
     * * `null` - null
     */
    code: 'not_a_list' | 'null';
    detail: string;
};

export type AnnotationsUpdateMetaProductProductDetailsIndexErrorComponent = {
    /**
     * * `meta.product.productDetails.INDEX` - meta.product.productDetails.INDEX
     */
    attr: 'meta.product.productDetails.INDEX';
    /**
     * * `not_a_dict` - not_a_dict
     * * `null` - null
     * * `required` - required
     */
    code: 'not_a_dict' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateMetaProductProductDetailsIndexkeyErrorComponent = {
    /**
     * * `meta.product.productDetails.INDEX.KEY` - meta.product.productDetails.INDEX.KEY
     */
    attr: 'meta.product.productDetails.INDEX.KEY';
    /**
     * * `required` - required
     */
    code: 'required';
    detail: string;
};

export type AnnotationsUpdateMetaProductProductRatingErrorComponent = {
    /**
     * * `meta.product.productRating` - meta.product.productRating
     */
    attr: 'meta.product.productRating';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductRetailPriceErrorComponent = {
    /**
     * * `meta.product.retailPrice` - meta.product.retailPrice
     */
    attr: 'meta.product.retailPrice';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsUpdateMetaProductSalesVolumeErrorComponent = {
    /**
     * * `meta.product.salesVolume` - meta.product.salesVolume
     */
    attr: 'meta.product.salesVolume';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductSecondaryOfferErrorComponent = {
    /**
     * * `meta.product.secondaryOffer` - meta.product.secondaryOffer
     */
    attr: 'meta.product.secondaryOffer';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type AnnotationsUpdateMetaProductSeriesErrorComponent = {
    /**
     * * `meta.product.series` - meta.product.series
     */
    attr: 'meta.product.series';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaProductVariationsErrorComponent = {
    /**
     * * `meta.product.variations` - meta.product.variations
     */
    attr: 'meta.product.variations';
    /**
     * * `not_a_list` - not_a_list
     * * `null` - null
     */
    code: 'not_a_list' | 'null';
    detail: string;
};

export type AnnotationsUpdateMetaProductVariationsIndexErrorComponent = {
    /**
     * * `meta.product.variations.INDEX` - meta.product.variations.INDEX
     */
    attr: 'meta.product.variations.INDEX';
    /**
     * * `not_a_dict` - not_a_dict
     * * `null` - null
     * * `required` - required
     */
    code: 'not_a_dict' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateMetaProductVariationsIndexkeyErrorComponent = {
    /**
     * * `meta.product.variations.INDEX.KEY` - meta.product.variations.INDEX.KEY
     */
    attr: 'meta.product.variations.INDEX.KEY';
    /**
     * * `required` - required
     */
    code: 'required';
    detail: string;
};

export type AnnotationsUpdateMetaThumbnailErrorComponent = {
    /**
     * * `meta.thumbnail` - meta.thumbnail
     */
    attr: 'meta.thumbnail';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateMetaUrlErrorComponent = {
    /**
     * * `meta.url` - meta.url
     */
    attr: 'meta.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type AnnotationsUpdateStartsAtErrorComponent = {
    /**
     * * `starts_at` - starts_at
     */
    attr: 'starts_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type AnnotationsUpdateTitleErrorComponent = {
    /**
     * * `title` - title
     */
    attr: 'title';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AnnotationsUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AnnotationsUpdateError>;
};

export type AnnotationsUpdateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

/**
 * Serializer for generating a signed URL for image asset uploads.
 *
 * It must be used with an authenticated view. While instantiating, the authenticated
 * user must be passed in the context.
 *
 * Example:
 * serializer = AssetUploadSerializer(request.data, context={'user': request.user})
 */
export type AssetUpload = {
    readonly signed_url: string;
    readonly path: string;
};

/**
 * Serializer for generating a signed URL for image asset uploads.
 *
 * It must be used with an authenticated view. While instantiating, the authenticated
 * user must be passed in the context.
 *
 * Example:
 * serializer = AssetUploadSerializer(request.data, context={'user': request.user})
 */
export type AssetUploadRequest = {
    filename: string;
};

export type AssetsCreateError = ({
    attr: 'non_field_errors';
} & AssetsCreateNonFieldErrorsErrorComponent) | ({
    attr: 'filename';
} & AssetsCreateFilenameErrorComponent);

export type AssetsCreateErrorResponse400 = ({
    type: 'validation_error';
} & AssetsCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type AssetsCreateFilenameErrorComponent = {
    /**
     * * `filename` - filename
     */
    attr: 'filename';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type AssetsCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `no_extension` - no_extension
     * * `null` - null
     */
    code: 'invalid' | 'no_extension' | 'null';
    detail: string;
};

export type AssetsCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<AssetsCreateError>;
};

/**
 * Serializer for changing the authenticated user's password.
 */
export type ChangePasswordRequest = {
    password: string;
    confirm_password: string;
    current_password: string;
};

export type Channel = {
    readonly id: string;
    readonly created_at: Date;
    readonly updated_at: Date;
    name: string;
    is_active?: boolean;
    subscription_plan?: SubscriptionPlanEnum;
    subscription_status?: string | null;
    subscription_expires_at?: Date | null;
    is_paid?: boolean;
    is_free?: boolean;
};

export type Chapter = {
    readonly id: string;
    meta: ChapterMeta;
    readonly created_at: Date;
    readonly updated_at: Date;
    is_deleted?: boolean;
    title: string;
    description: string;
    /**
     * Time in seconds
     */
    starts_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
    user: string;
};

export type ChapterMeta = {
    thumbnail?: string;
    url?: string;
};

export type ChapterMetaRequest = {
    thumbnail?: string;
    url?: string;
};

export type ChapterMetrics = {
    seeks?: number;
};

export type ChapterRequest = {
    meta: ChapterMetaRequest;
    is_deleted?: boolean;
    title: string;
    description: string;
    /**
     * Time in seconds
     */
    starts_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
    user: string;
};

export type ChaptersCreateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersCreateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersCreateError = ({
    attr: 'non_field_errors';
} & ChaptersCreateNonFieldErrorsErrorComponent) | ({
    attr: 'title';
} & ChaptersCreateTitleErrorComponent) | ({
    attr: 'description';
} & ChaptersCreateDescriptionErrorComponent) | ({
    attr: 'meta.non_field_errors';
} & ChaptersCreateMetaNonFieldErrorsErrorComponent) | ({
    attr: 'meta.thumbnail';
} & ChaptersCreateMetaThumbnailErrorComponent) | ({
    attr: 'meta.url';
} & ChaptersCreateMetaUrlErrorComponent) | ({
    attr: 'is_deleted';
} & ChaptersCreateIsDeletedErrorComponent) | ({
    attr: 'starts_at';
} & ChaptersCreateStartsAtErrorComponent) | ({
    attr: 'is_sponsored';
} & ChaptersCreateIsSponsoredErrorComponent) | ({
    attr: 'channel';
} & ChaptersCreateChannelErrorComponent) | ({
    attr: 'video';
} & ChaptersCreateVideoErrorComponent);

export type ChaptersCreateErrorResponse400 = ({
    type: 'validation_error';
} & ChaptersCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type ChaptersCreateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersCreateIsSponsoredErrorComponent = {
    /**
     * * `is_sponsored` - is_sponsored
     */
    attr: 'is_sponsored';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersCreateMetaNonFieldErrorsErrorComponent = {
    /**
     * * `meta.non_field_errors` - meta.non_field_errors
     */
    attr: 'meta.non_field_errors';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type ChaptersCreateMetaThumbnailErrorComponent = {
    /**
     * * `meta.thumbnail` - meta.thumbnail
     */
    attr: 'meta.thumbnail';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersCreateMetaUrlErrorComponent = {
    /**
     * * `meta.url` - meta.url
     */
    attr: 'meta.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersCreateStartsAtErrorComponent = {
    /**
     * * `starts_at` - starts_at
     */
    attr: 'starts_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type ChaptersCreateTitleErrorComponent = {
    /**
     * * `title` - title
     */
    attr: 'title';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<ChaptersCreateError>;
};

export type ChaptersCreateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersDestroyErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type ChaptersListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type ChaptersPartialUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersPartialUpdateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersPartialUpdateError = ({
    attr: 'non_field_errors';
} & ChaptersPartialUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'meta.non_field_errors';
} & ChaptersPartialUpdateMetaNonFieldErrorsErrorComponent) | ({
    attr: 'meta.thumbnail';
} & ChaptersPartialUpdateMetaThumbnailErrorComponent) | ({
    attr: 'meta.url';
} & ChaptersPartialUpdateMetaUrlErrorComponent) | ({
    attr: 'is_deleted';
} & ChaptersPartialUpdateIsDeletedErrorComponent) | ({
    attr: 'title';
} & ChaptersPartialUpdateTitleErrorComponent) | ({
    attr: 'description';
} & ChaptersPartialUpdateDescriptionErrorComponent) | ({
    attr: 'starts_at';
} & ChaptersPartialUpdateStartsAtErrorComponent) | ({
    attr: 'is_sponsored';
} & ChaptersPartialUpdateIsSponsoredErrorComponent) | ({
    attr: 'channel';
} & ChaptersPartialUpdateChannelErrorComponent) | ({
    attr: 'video';
} & ChaptersPartialUpdateVideoErrorComponent) | ({
    attr: 'user';
} & ChaptersPartialUpdateUserErrorComponent);

export type ChaptersPartialUpdateErrorResponse400 = ({
    type: 'validation_error';
} & ChaptersPartialUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type ChaptersPartialUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersPartialUpdateIsSponsoredErrorComponent = {
    /**
     * * `is_sponsored` - is_sponsored
     */
    attr: 'is_sponsored';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersPartialUpdateMetaNonFieldErrorsErrorComponent = {
    /**
     * * `meta.non_field_errors` - meta.non_field_errors
     */
    attr: 'meta.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type ChaptersPartialUpdateMetaThumbnailErrorComponent = {
    /**
     * * `meta.thumbnail` - meta.thumbnail
     */
    attr: 'meta.thumbnail';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersPartialUpdateMetaUrlErrorComponent = {
    /**
     * * `meta.url` - meta.url
     */
    attr: 'meta.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersPartialUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersPartialUpdateStartsAtErrorComponent = {
    /**
     * * `starts_at` - starts_at
     */
    attr: 'starts_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type ChaptersPartialUpdateTitleErrorComponent = {
    /**
     * * `title` - title
     */
    attr: 'title';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersPartialUpdateUserErrorComponent = {
    /**
     * * `user` - user
     */
    attr: 'user';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersPartialUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<ChaptersPartialUpdateError>;
};

export type ChaptersPartialUpdateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type ChaptersUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersUpdateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersUpdateError = ({
    attr: 'non_field_errors';
} & ChaptersUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'meta.non_field_errors';
} & ChaptersUpdateMetaNonFieldErrorsErrorComponent) | ({
    attr: 'meta.thumbnail';
} & ChaptersUpdateMetaThumbnailErrorComponent) | ({
    attr: 'meta.url';
} & ChaptersUpdateMetaUrlErrorComponent) | ({
    attr: 'is_deleted';
} & ChaptersUpdateIsDeletedErrorComponent) | ({
    attr: 'title';
} & ChaptersUpdateTitleErrorComponent) | ({
    attr: 'description';
} & ChaptersUpdateDescriptionErrorComponent) | ({
    attr: 'starts_at';
} & ChaptersUpdateStartsAtErrorComponent) | ({
    attr: 'is_sponsored';
} & ChaptersUpdateIsSponsoredErrorComponent) | ({
    attr: 'channel';
} & ChaptersUpdateChannelErrorComponent) | ({
    attr: 'video';
} & ChaptersUpdateVideoErrorComponent) | ({
    attr: 'user';
} & ChaptersUpdateUserErrorComponent);

export type ChaptersUpdateErrorResponse400 = ({
    type: 'validation_error';
} & ChaptersUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type ChaptersUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersUpdateIsSponsoredErrorComponent = {
    /**
     * * `is_sponsored` - is_sponsored
     */
    attr: 'is_sponsored';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersUpdateMetaNonFieldErrorsErrorComponent = {
    /**
     * * `meta.non_field_errors` - meta.non_field_errors
     */
    attr: 'meta.non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type ChaptersUpdateMetaThumbnailErrorComponent = {
    /**
     * * `meta.thumbnail` - meta.thumbnail
     */
    attr: 'meta.thumbnail';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersUpdateMetaUrlErrorComponent = {
    /**
     * * `meta.url` - meta.url
     */
    attr: 'meta.url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type ChaptersUpdateStartsAtErrorComponent = {
    /**
     * * `starts_at` - starts_at
     */
    attr: 'starts_at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     * * `max_value` - max_value
     * * `min_value` - min_value
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
};

export type ChaptersUpdateTitleErrorComponent = {
    /**
     * * `title` - title
     */
    attr: 'title';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type ChaptersUpdateUserErrorComponent = {
    /**
     * * `user` - user
     */
    attr: 'user';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type ChaptersUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<ChaptersUpdateError>;
};

export type ChaptersUpdateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type CheckoutMeta = {
    video_id?: string | null;
    video_key?: string | null;
    lang_code?: string | null;
    dub_id?: string | null;
};

export type CheckoutsCancelRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type CheckoutsChannelsRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type CheckoutsCreateChannelIdErrorComponent = {
    /**
     * * `channel_id` - channel_id
     */
    attr: 'channel_id';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid' | 'null' | 'required';
    detail: string;
};

export type CheckoutsCreateError = ({
    attr: 'non_field_errors';
} & CheckoutsCreateNonFieldErrorsErrorComponent) | ({
    attr: 'channel_id';
} & CheckoutsCreateChannelIdErrorComponent) | ({
    attr: 'plan';
} & CheckoutsCreatePlanErrorComponent) | ({
    attr: 'mode';
} & CheckoutsCreateModeErrorComponent) | ({
    attr: 'video_id';
} & CheckoutsCreateVideoIdErrorComponent) | ({
    attr: 'lang_code';
} & CheckoutsCreateLangCodeErrorComponent);

export type CheckoutsCreateErrorResponse400 = ({
    type: 'validation_error';
} & CheckoutsCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type CheckoutsCreateLangCodeErrorComponent = {
    /**
     * * `lang_code` - lang_code
     */
    attr: 'lang_code';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type CheckoutsCreateModeErrorComponent = {
    /**
     * * `mode` - mode
     */
    attr: 'mode';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
};

export type CheckoutsCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type CheckoutsCreatePlanErrorComponent = {
    /**
     * * `plan` - plan
     */
    attr: 'plan';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     * * `required` - required
     */
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
};

export type CheckoutsCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<CheckoutsCreateError>;
};

export type CheckoutsCreateVideoIdErrorComponent = {
    /**
     * * `video_id` - video_id
     */
    attr: 'video_id';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type CheckoutsInvoiceRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type CheckoutsSuccessRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type CheckoutsThanksRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

/**
 * * `client_error` - Client Error
 */
export const ClientErrorEnum = { CLIENT_ERROR: 'client_error' } as const;

/**
 * * `client_error` - Client Error
 */
export type ClientErrorEnum = typeof ClientErrorEnum[keyof typeof ClientErrorEnum];

/**
 * Serializer for confirming password reset. Signals the Temporal workflow.
 */
export type ConfirmResetRequest = {
    token: string;
};

/**
 * Serializer for creating chapters of a video.
 */
export type CreateChapterRequest = {
    title: string;
    description: string;
    meta?: ChapterMetaRequest | null;
    is_deleted?: boolean;
    /**
     * Time in seconds
     */
    starts_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
};

/**
 * Validates data and initiates a Stripe checkout session and workflow.
 */
export type CreateCheckoutRequest = {
    channel_id: string;
    plan: PlanEnum;
    mode: ModeEnum;
    video_id?: string;
    lang_code?: string;
};

export type Detail = {
    detail: string;
};

export type DownloadrRequest = {
    url: string;
};

export type Dub = {
    readonly id: string;
    readonly key: string;
    readonly created_at: Date;
    readonly updated_at: Date;
    is_deleted?: boolean;
    elevenlabs_id?: string | null;
    path?: string | null;
    state?: DubStateEnum;
    lang_code: string;
    transcript?: unknown;
    transcript_status?: TranscriptStatusEnum;
    channel: string;
    video: string;
};

export type DubRequest = {
    is_deleted?: boolean;
    elevenlabs_id?: string | null;
    path?: string | null;
    state?: DubStateEnum;
    lang_code: string;
    transcript?: unknown;
    transcript_status?: TranscriptStatusEnum;
    channel: string;
    video: string;
};

/**
 * * `dubbing` - Dubbing
 * * `encoding` - Encoding
 * * `draft` - Draft
 * * `public` - Public
 * * `failed` - Failed
 */
export const DubStateEnum = {
    DUBBING: 'dubbing',
    ENCODING: 'encoding',
    DRAFT: 'draft',
    PUBLIC: 'public',
    FAILED: 'failed'
} as const;

/**
 * * `dubbing` - Dubbing
 * * `encoding` - Encoding
 * * `draft` - Draft
 * * `public` - Public
 * * `failed` - Failed
 */
export type DubStateEnum = typeof DubStateEnum[keyof typeof DubStateEnum];

export type DubsCreateError = ({
    attr: 'non_field_errors';
} & DubsCreateNonFieldErrorsErrorComponent) | ({
    attr: 'key';
} & DubsCreateKeyErrorComponent) | ({
    attr: 'lang_code';
} & DubsCreateLangCodeErrorComponent);

export type DubsCreateErrorResponse400 = ({
    type: 'validation_error';
} & DubsCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type DubsCreateKeyErrorComponent = {
    /**
     * * `key` - key
     */
    attr: 'key';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsCreateLangCodeErrorComponent = {
    /**
     * * `lang_code` - lang_code
     */
    attr: 'lang_code';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<DubsCreateError>;
};

export type DubsDestroyErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type DubsListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type DubsPartialUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type DubsPartialUpdateElevenlabsIdErrorComponent = {
    /**
     * * `elevenlabs_id` - elevenlabs_id
     */
    attr: 'elevenlabs_id';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsPartialUpdateError = ({
    attr: 'non_field_errors';
} & DubsPartialUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'is_deleted';
} & DubsPartialUpdateIsDeletedErrorComponent) | ({
    attr: 'elevenlabs_id';
} & DubsPartialUpdateElevenlabsIdErrorComponent) | ({
    attr: 'path';
} & DubsPartialUpdatePathErrorComponent) | ({
    attr: 'state';
} & DubsPartialUpdateStateErrorComponent) | ({
    attr: 'lang_code';
} & DubsPartialUpdateLangCodeErrorComponent) | ({
    attr: 'transcript';
} & DubsPartialUpdateTranscriptErrorComponent) | ({
    attr: 'transcript_status';
} & DubsPartialUpdateTranscriptStatusErrorComponent) | ({
    attr: 'channel';
} & DubsPartialUpdateChannelErrorComponent) | ({
    attr: 'video';
} & DubsPartialUpdateVideoErrorComponent);

export type DubsPartialUpdateErrorResponse400 = ({
    type: 'validation_error';
} & DubsPartialUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type DubsPartialUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsPartialUpdateLangCodeErrorComponent = {
    /**
     * * `lang_code` - lang_code
     */
    attr: 'lang_code';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsPartialUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsPartialUpdatePathErrorComponent = {
    /**
     * * `path` - path
     */
    attr: 'path';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsPartialUpdateStateErrorComponent = {
    /**
     * * `state` - state
     */
    attr: 'state';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     */
    code: 'invalid_choice' | 'null';
    detail: string;
};

export type DubsPartialUpdateTranscriptErrorComponent = {
    /**
     * * `transcript` - transcript
     */
    attr: 'transcript';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsPartialUpdateTranscriptStatusErrorComponent = {
    /**
     * * `transcript_status` - transcript_status
     */
    attr: 'transcript_status';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     */
    code: 'invalid_choice' | 'null';
    detail: string;
};

export type DubsPartialUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<DubsPartialUpdateError>;
};

export type DubsPartialUpdateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type DubsRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type DubsUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type DubsUpdateElevenlabsIdErrorComponent = {
    /**
     * * `elevenlabs_id` - elevenlabs_id
     */
    attr: 'elevenlabs_id';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsUpdateError = ({
    attr: 'non_field_errors';
} & DubsUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'is_deleted';
} & DubsUpdateIsDeletedErrorComponent) | ({
    attr: 'elevenlabs_id';
} & DubsUpdateElevenlabsIdErrorComponent) | ({
    attr: 'path';
} & DubsUpdatePathErrorComponent) | ({
    attr: 'state';
} & DubsUpdateStateErrorComponent) | ({
    attr: 'lang_code';
} & DubsUpdateLangCodeErrorComponent) | ({
    attr: 'transcript';
} & DubsUpdateTranscriptErrorComponent) | ({
    attr: 'transcript_status';
} & DubsUpdateTranscriptStatusErrorComponent) | ({
    attr: 'channel';
} & DubsUpdateChannelErrorComponent) | ({
    attr: 'video';
} & DubsUpdateVideoErrorComponent);

export type DubsUpdateErrorResponse400 = ({
    type: 'validation_error';
} & DubsUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type DubsUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsUpdateLangCodeErrorComponent = {
    /**
     * * `lang_code` - lang_code
     */
    attr: 'lang_code';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsUpdatePathErrorComponent = {
    /**
     * * `path` - path
     */
    attr: 'path';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type DubsUpdateStateErrorComponent = {
    /**
     * * `state` - state
     */
    attr: 'state';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     */
    code: 'invalid_choice' | 'null';
    detail: string;
};

export type DubsUpdateTranscriptErrorComponent = {
    /**
     * * `transcript` - transcript
     */
    attr: 'transcript';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type DubsUpdateTranscriptStatusErrorComponent = {
    /**
     * * `transcript_status` - transcript_status
     */
    attr: 'transcript_status';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     */
    code: 'invalid_choice' | 'null';
    detail: string;
};

export type DubsUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<DubsUpdateError>;
};

export type DubsUpdateVideoErrorComponent = {
    /**
     * * `video` - video
     */
    attr: 'video';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type Error401 = {
    code: ErrorCode401Enum;
    detail: string;
    attr: string | null;
};

export type Error404 = {
    code: ErrorCode404Enum;
    detail: string;
    attr: string | null;
};

export type Error500 = {
    code: ErrorCode500Enum;
    detail: string;
    attr: string | null;
};

/**
 * * `authentication_failed` - Authentication Failed
 * * `not_authenticated` - Not Authenticated
 */
export const ErrorCode401Enum = { AUTHENTICATION_FAILED: 'authentication_failed', NOT_AUTHENTICATED: 'not_authenticated' } as const;

/**
 * * `authentication_failed` - Authentication Failed
 * * `not_authenticated` - Not Authenticated
 */
export type ErrorCode401Enum = typeof ErrorCode401Enum[keyof typeof ErrorCode401Enum];

/**
 * * `not_found` - Not Found
 */
export const ErrorCode404Enum = { NOT_FOUND: 'not_found' } as const;

/**
 * * `not_found` - Not Found
 */
export type ErrorCode404Enum = typeof ErrorCode404Enum[keyof typeof ErrorCode404Enum];

/**
 * * `error` - Error
 */
export const ErrorCode500Enum = { ERROR: 'error' } as const;

/**
 * * `error` - Error
 */
export type ErrorCode500Enum = typeof ErrorCode500Enum[keyof typeof ErrorCode500Enum];

export type ErrorResponse401 = {
    type: ClientErrorEnum;
    errors: Array<Error401>;
};

export type ErrorResponse404 = {
    type: ClientErrorEnum;
    errors: Array<Error404>;
};

export type ErrorResponse500 = {
    type: ServerErrorEnum;
    errors: Array<Error500>;
};

export type Event = {
    id: string;
    name: string;
    kind: string;
    user_id?: string | null;
    channel_id: string;
    video_id: string;
    playback_id: string;
    timestamp: Date;
};

/**
 * Serializer for the aggregated top data.
 */
export type Insights = {
    top: Array<RankedPropertiesById>;
    product: number;
    location: number;
    url: number;
    chapter: number;
};

export type Invoice = {
    id: string | null;
    number: string | null;
    status: string | null;
    pdf_url: string | null;
    hosted_url: string | null;
    total: number;
    subtotal: number;
    tax: number;
    amount_paid: number;
    issued_at: Date | null;
    paid_at: Date | null;
    customer_name: string | null;
    customer_email: string | null;
    line_items: Array<InvoiceLineItem>;
};

export type InvoiceLineItem = {
    description: string;
    quantity: number;
    unit_price: number;
    amount: number;
};

/**
 * * `product` - Product
 * * `url` - Url
 * * `location` - Location
 * * `person` - Person
 */
export const KindEnum = {
    PRODUCT: 'product',
    URL: 'url',
    LOCATION: 'location',
    PERSON: 'person'
} as const;

/**
 * * `product` - Product
 * * `url` - Url
 * * `location` - Location
 * * `person` - Person
 */
export type KindEnum = typeof KindEnum[keyof typeof KindEnum];

export type LinkParseLinkRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type Location = {
    latitude?: number | null;
    longitude?: number | null;
    url?: string | null;
};

export type LocationRequest = {
    latitude?: number | null;
    longitude?: number | null;
    url?: string | null;
};

/**
 * * `setup` - setup
 * * `payment` - payment
 * * `subscription` - subscription
 */
export const ModeEnum = {
    SETUP: 'setup',
    PAYMENT: 'payment',
    SUBSCRIPTION: 'subscription'
} as const;

/**
 * * `setup` - setup
 * * `payment` - payment
 * * `subscription` - subscription
 */
export type ModeEnum = typeof ModeEnum[keyof typeof ModeEnum];

export type OnboardCreateConfirmPasswordErrorComponent = {
    /**
     * * `confirm_password` - confirm_password
     */
    attr: 'confirm_password';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `min_length` - min_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'min_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type OnboardCreateEmailErrorComponent = {
    /**
     * * `email` - email
     */
    attr: 'email';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type OnboardCreateError = ({
    attr: 'non_field_errors';
} & OnboardCreateNonFieldErrorsErrorComponent) | ({
    attr: 'email';
} & OnboardCreateEmailErrorComponent) | ({
    attr: 'username';
} & OnboardCreateUsernameErrorComponent) | ({
    attr: 'password';
} & OnboardCreatePasswordErrorComponent) | ({
    attr: 'confirm_password';
} & OnboardCreateConfirmPasswordErrorComponent);

export type OnboardCreateErrorResponse400 = ({
    type: 'validation_error';
} & OnboardCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type OnboardCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `duplicate_email` - duplicate_email
     * * `duplicate_username` - duplicate_username
     * * `invalid` - invalid
     * * `invalid_username` - invalid_username
     * * `null` - null
     * * `password_mismatch` - password_mismatch
     */
    code: 'duplicate_email' | 'duplicate_username' | 'invalid' | 'invalid_username' | 'null' | 'password_mismatch';
    detail: string;
};

export type OnboardCreatePasswordErrorComponent = {
    /**
     * * `password` - password
     */
    attr: 'password';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `min_length` - min_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'min_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type OnboardCreateUsernameErrorComponent = {
    /**
     * * `username` - username
     */
    attr: 'username';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type OnboardCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<OnboardCreateError>;
};

/**
 * Serializer for new user onboarding.
 *
 * Creates a user, channel, API key, and initiates the Temporal onboarding workflow.
 */
export type OnboardRequest = {
    email: string;
    username: string;
};

export type OnboardVerifyRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type PaginatedCheckoutList = {
    count: number;
    next: string | null;
    previous: string | null;
    results: Array<StripeCheckoutSuccess>;
};

export type PaginatedEventList = {
    next?: string;
    previous?: string;
    results: Array<Event>;
};

export type ParseError = {
    code: ParseErrorCodeEnum;
    detail: string;
    attr: string | null;
};

/**
 * * `parse_error` - Parse Error
 */
export const ParseErrorCodeEnum = { PARSE_ERROR: 'parse_error' } as const;

/**
 * * `parse_error` - Parse Error
 */
export type ParseErrorCodeEnum = typeof ParseErrorCodeEnum[keyof typeof ParseErrorCodeEnum];

export type ParseErrorResponse = {
    type: ClientErrorEnum;
    errors: Array<ParseError>;
};

/**
 * Serializer for parsing a URL and returning its metadata.
 */
export type ParseLink = {
    readonly original_url: string;
    readonly title: string;
    readonly description: string;
    readonly image_url: string;
};

export type PatchedAnnotationRequest = {
    title?: string;
    description?: string;
    meta?: AnnotationMetaRequest;
    is_deleted?: boolean;
    kind?: KindEnum;
    /**
     * Time in seconds
     */
    starts_at?: number;
    /**
     * Time in seconds
     */
    ends_at?: number;
    is_sponsored?: boolean;
    channel?: string;
    video?: string;
};

export type PatchedChapterRequest = {
    meta?: ChapterMetaRequest;
    is_deleted?: boolean;
    title?: string;
    description?: string;
    /**
     * Time in seconds
     */
    starts_at?: number;
    is_sponsored?: boolean;
    channel?: string;
    video?: string;
    user?: string;
};

export type PatchedDubRequest = {
    is_deleted?: boolean;
    elevenlabs_id?: string | null;
    path?: string | null;
    state?: DubStateEnum;
    lang_code?: string;
    transcript?: unknown;
    transcript_status?: TranscriptStatusEnum;
    channel?: string;
    video?: string;
};

/**
 * Serializer for updating user profile data.
 *
 * Only allows updating first_name, last_name, and profile_picture.
 * Profile picture should be a path from the /assets endpoint.
 */
export type PatchedProfileUpdateRequest = {
    first_name?: string;
    last_name?: string;
    profile_picture?: string;
};

export type PatchedVideoRequest = {
    name?: string;
    description?: string;
    is_deleted?: boolean;
    path?: string | null;
    thumbnail?: string | null;
    state?: VideoStateEnum;
    meta?: unknown;
    channel?: string;
    upload_by?: string;
};

/**
 * * `basic_monthly` - Basic Monthly
 * * `basic_yearly` - Basic Yearly
 * * `dub` - Dub
 */
export const PlanEnum = {
    BASIC_MONTHLY: 'basic_monthly',
    BASIC_YEARLY: 'basic_yearly',
    DUB: 'dub'
} as const;

/**
 * * `basic_monthly` - Basic Monthly
 * * `basic_yearly` - Basic Yearly
 * * `dub` - Dub
 */
export type PlanEnum = typeof PlanEnum[keyof typeof PlanEnum];

export type ProductsAmazonSearchRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

/**
 * Serializer for reading user profile data.
 *
 * Uses explicit fields list to prevent accidental exposure of sensitive data.
 */
export type ProfileRead = {
    readonly id: string;
    readonly first_name: string | null;
    readonly last_name: string | null;
    readonly email: string;
    readonly username: string;
    readonly meta: UserMeta;
    readonly is_active: boolean;
    readonly is_verified: boolean;
    readonly is_service_account: boolean;
    readonly created_at: Date;
    readonly updated_at: Date;
    readonly last_login: Date | null;
    readonly channel: Channel;
};

export type ProfileRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type PulseAnnotationAnalyticsRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type PulseAnnotationsRetrieveError = ({
    attr: 'timestamp__gte';
} & PulseAnnotationsRetrieveTimestampGteErrorComponent) | ({
    attr: 'timestamp__lte';
} & PulseAnnotationsRetrieveTimestampLteErrorComponent);

export type PulseAnnotationsRetrieveErrorResponse400 = ({
    type: 'validation_error';
} & PulseAnnotationsRetrieveValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type PulseAnnotationsRetrieveTimestampGteErrorComponent = {
    /**
     * * `timestamp__gte` - timestamp__gte
     */
    attr: 'timestamp__gte';
    /**
     * * `invalid` - invalid
     * * `required` - required
     */
    code: 'invalid' | 'required';
    detail: string;
};

export type PulseAnnotationsRetrieveTimestampLteErrorComponent = {
    /**
     * * `timestamp__lte` - timestamp__lte
     */
    attr: 'timestamp__lte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseAnnotationsRetrieveValidationError = {
    type: ValidationErrorEnum;
    errors: Array<PulseAnnotationsRetrieveError>;
};

export type PulseChapterAnalyticsRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type PulseChaptersRetrieveError = ({
    attr: 'timestamp__gte';
} & PulseChaptersRetrieveTimestampGteErrorComponent) | ({
    attr: 'timestamp__lte';
} & PulseChaptersRetrieveTimestampLteErrorComponent);

export type PulseChaptersRetrieveErrorResponse400 = ({
    type: 'validation_error';
} & PulseChaptersRetrieveValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type PulseChaptersRetrieveTimestampGteErrorComponent = {
    /**
     * * `timestamp__gte` - timestamp__gte
     */
    attr: 'timestamp__gte';
    /**
     * * `invalid` - invalid
     * * `required` - required
     */
    code: 'invalid' | 'required';
    detail: string;
};

export type PulseChaptersRetrieveTimestampLteErrorComponent = {
    /**
     * * `timestamp__lte` - timestamp__lte
     */
    attr: 'timestamp__lte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseChaptersRetrieveValidationError = {
    type: ValidationErrorEnum;
    errors: Array<PulseChaptersRetrieveError>;
};

export type PulseInsightsRetrieveError = ({
    attr: 'timestamp__gte';
} & PulseInsightsRetrieveTimestampGteErrorComponent) | ({
    attr: 'timestamp__lte';
} & PulseInsightsRetrieveTimestampLteErrorComponent) | ({
    attr: 'name';
} & PulseInsightsRetrieveNameErrorComponent) | ({
    attr: 'kind';
} & PulseInsightsRetrieveKindErrorComponent);

export type PulseInsightsRetrieveErrorResponse400 = ({
    type: 'validation_error';
} & PulseInsightsRetrieveValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type PulseInsightsRetrieveKindErrorComponent = {
    /**
     * * `kind` - kind
     */
    attr: 'kind';
    /**
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     */
    code: 'null_characters_not_allowed' | 'required';
    detail: string;
};

export type PulseInsightsRetrieveNameErrorComponent = {
    /**
     * * `name` - name
     */
    attr: 'name';
    /**
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     */
    code: 'null_characters_not_allowed' | 'required';
    detail: string;
};

export type PulseInsightsRetrieveTimestampGteErrorComponent = {
    /**
     * * `timestamp__gte` - timestamp__gte
     */
    attr: 'timestamp__gte';
    /**
     * * `invalid` - invalid
     * * `required` - required
     */
    code: 'invalid' | 'required';
    detail: string;
};

export type PulseInsightsRetrieveTimestampLteErrorComponent = {
    /**
     * * `timestamp__lte` - timestamp__lte
     */
    attr: 'timestamp__lte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseInsightsRetrieveValidationError = {
    type: ValidationErrorEnum;
    errors: Array<PulseInsightsRetrieveError>;
};

export type PulseListError = ({
    attr: 'timestamp__gte';
} & PulseListTimestampGteErrorComponent) | ({
    attr: 'timestamp__lte';
} & PulseListTimestampLteErrorComponent);

export type PulseListErrorResponse400 = ({
    type: 'validation_error';
} & PulseListValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type PulseListTimestampGteErrorComponent = {
    /**
     * * `timestamp__gte` - timestamp__gte
     */
    attr: 'timestamp__gte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseListTimestampLteErrorComponent = {
    /**
     * * `timestamp__lte` - timestamp__lte
     */
    attr: 'timestamp__lte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseListValidationError = {
    type: ValidationErrorEnum;
    errors: Array<PulseListError>;
};

export type PulseRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type PulseSummary = {
    impressions?: number;
    expands?: number;
    clickthroughs?: number;
    seeks?: number;
};

export type PulseSummaryRetrieveError = ({
    attr: 'timestamp__gte';
} & PulseSummaryRetrieveTimestampGteErrorComponent) | ({
    attr: 'timestamp__lte';
} & PulseSummaryRetrieveTimestampLteErrorComponent);

export type PulseSummaryRetrieveErrorResponse400 = ({
    type: 'validation_error';
} & PulseSummaryRetrieveValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type PulseSummaryRetrieveTimestampGteErrorComponent = {
    /**
     * * `timestamp__gte` - timestamp__gte
     */
    attr: 'timestamp__gte';
    /**
     * * `invalid` - invalid
     * * `required` - required
     */
    code: 'invalid' | 'required';
    detail: string;
};

export type PulseSummaryRetrieveTimestampLteErrorComponent = {
    /**
     * * `timestamp__lte` - timestamp__lte
     */
    attr: 'timestamp__lte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseSummaryRetrieveValidationError = {
    type: ValidationErrorEnum;
    errors: Array<PulseSummaryRetrieveError>;
};

export type PulseVideoAnalyticsRetrieveError = ({
    attr: 'timestamp__gte';
} & PulseVideoAnalyticsRetrieveTimestampGteErrorComponent) | ({
    attr: 'timestamp__lte';
} & PulseVideoAnalyticsRetrieveTimestampLteErrorComponent);

export type PulseVideoAnalyticsRetrieveErrorResponse400 = ({
    type: 'validation_error';
} & PulseVideoAnalyticsRetrieveValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type PulseVideoAnalyticsRetrieveTimestampGteErrorComponent = {
    /**
     * * `timestamp__gte` - timestamp__gte
     */
    attr: 'timestamp__gte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseVideoAnalyticsRetrieveTimestampLteErrorComponent = {
    /**
     * * `timestamp__lte` - timestamp__lte
     */
    attr: 'timestamp__lte';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type PulseVideoAnalyticsRetrieveValidationError = {
    type: ValidationErrorEnum;
    errors: Array<PulseVideoAnalyticsRetrieveError>;
};

export type RankedPropertiesById = {
    id: string;
    count: number;
    title?: string;
    description?: string;
    kind?: string;
    video_id?: string;
    video_key?: string;
    video_name?: string;
};

export type RequestDub = {
    readonly id: string;
    readonly duration: number;
    key: string;
    lang_code: string;
};

export type RequestDubRequest = {
    key: string;
    lang_code: string;
};

/**
 * Serializer for initiating the password reset process
 */
export type ResetPasswordSerialzierRequest = {
    email: string;
};

export type SchemaRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

/**
 * * `server_error` - Server Error
 */
export const ServerErrorEnum = { SERVER_ERROR: 'server_error' } as const;

/**
 * * `server_error` - Server Error
 */
export type ServerErrorEnum = typeof ServerErrorEnum[keyof typeof ServerErrorEnum];

/**
 * Serializer for sharing a video via email.
 */
export type ShareVideoRequest = {
    email_from: string;
    email_to: string;
    key: string;
    at?: number | null;
    chapter_id?: string | null;
    ant_id?: string | null;
};

/**
 * * `pending` - Pending
 * * `success` - Success
 * * `failure` - Failure
 * * `canceled` - Canceled
 * * `expired` - Expired
 */
export const StatusEnum = {
    PENDING: 'pending',
    SUCCESS: 'success',
    FAILURE: 'failure',
    CANCELED: 'canceled',
    EXPIRED: 'expired'
} as const;

/**
 * * `pending` - Pending
 * * `success` - Success
 * * `failure` - Failure
 * * `canceled` - Canceled
 * * `expired` - Expired
 */
export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];

/**
 * Serializes the StripeCheckout model instance.
 */
export type StripeCheckout = {
    readonly id: string;
    /**
     * Returns the URL for a successful Stripe checkout.
     */
    readonly success_url: string;
    /**
     * Returns the URL for a canceled Stripe checkout.
     */
    readonly cancel_url: string;
    /**
     * Returns the URL for Stripe to return to after checkout.
     */
    readonly return_url: string;
    readonly stripe_price_id: string;
    readonly meta: StripeCheckoutMeta;
    readonly created_at: Date;
    readonly updated_at: Date;
    session?: string | null;
    status?: StatusEnum;
    plan?: PlanEnum;
    stripe_invoice_id?: string | null;
    invoice_number?: string | null;
    invoice_status?: string | null;
    invoice_pdf_url?: string | null;
    invoice_hosted_url?: string | null;
    invoice_subtotal?: number | null;
    invoice_tax?: number | null;
    invoice_total?: number | null;
    invoice_amount_paid?: number | null;
    invoice_issued_at?: Date | null;
    invoice_paid_at?: Date | null;
    invoice_period_start?: Date | null;
    invoice_period_end?: Date | null;
    invoice_customer_name?: string | null;
    invoice_customer_email?: string | null;
    channel: string;
};

/**
 * Serializes the meta field of the StripeCheckout model.
 */
export type StripeCheckoutMeta = {
    readonly stripe_session_url: string;
};

/**
 * Serializes checkout data for success/thanks pages.
 *
 * Excludes sensitive fields like stripe_price_id from meta.
 * Includes structured invoice data if available.
 */
export type StripeCheckoutSuccess = {
    readonly id: string;
    plan?: PlanEnum;
    status?: StatusEnum;
    readonly meta: CheckoutMeta;
    readonly invoice: Invoice | null;
    readonly created_at: Date;
    readonly updated_at: Date;
};

/**
 * * `free` - Free
 * * `standard` - Standard
 * * `premium` - Premium
 */
export const SubscriptionPlanEnum = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium'
} as const;

/**
 * * `free` - Free
 * * `standard` - Standard
 * * `premium` - Premium
 */
export type SubscriptionPlanEnum = typeof SubscriptionPlanEnum[keyof typeof SubscriptionPlanEnum];

export type TokenObtainSliding = {
    readonly token: string;
};

export type TokenObtainSlidingRequest = {
    username: string;
    password: string;
};

export type TokenRefreshSliding = {
    token: string;
};

export type TokenRefreshSlidingRequest = {
    token: string;
};

/**
 * * `pending` - Pending
 * * `fetching` - Fetching
 * * `completed` - Completed
 * * `failed` - Failed
 */
export const TranscriptStatusEnum = {
    PENDING: 'pending',
    FETCHING: 'fetching',
    COMPLETED: 'completed',
    FAILED: 'failed'
} as const;

/**
 * * `pending` - Pending
 * * `fetching` - Fetching
 * * `completed` - Completed
 * * `failed` - Failed
 */
export type TranscriptStatusEnum = typeof TranscriptStatusEnum[keyof typeof TranscriptStatusEnum];

/**
 * Serializer for video upload, creating Video object and returning signed URL.
 */
export type UploadVideo = {
    readonly signed_url: string;
    readonly video: Video;
};

/**
 * Serializer for video upload, creating Video object and returning signed URL.
 */
export type UploadVideoRequest = {
    filename: string;
};

export type UserMeta = {
    channel_id?: string | null;
    profile_picture?: string | null;
};

/**
 * Serializer for creating and validating username reservations.
 */
export type UsernameReservationRequest = {
    username: string;
    email: string;
};

/**
 * * `validation_error` - Validation Error
 */
export const ValidationErrorEnum = { VALIDATION_ERROR: 'validation_error' } as const;

/**
 * * `validation_error` - Validation Error
 */
export type ValidationErrorEnum = typeof ValidationErrorEnum[keyof typeof ValidationErrorEnum];

export type Video = {
    readonly id: string;
    name: string;
    description: string;
    /**
     * Gets the number of views for the video.
     */
    readonly views: number;
    /**
     * Extract duration from meta, caching it after the first successful read.
     *
     * This property first checks for a 'duration' key at the top level of the meta JSON field.
     * If not found, it attempts to extract it from the nested 'probe.format.duration' path.
     * Once found, it is saved to the top level of the meta field for efficient future access.
     */
    readonly duration: number;
    /**
     * Check if video uses legacy path format or new format.
     */
    readonly is_legacy: boolean;
    /**
     * Gets encoded id for channel.
     */
    readonly short_channel_id: string;
    readonly channel_is_free: boolean;
    readonly created_at: Date;
    readonly updated_at: Date;
    is_deleted?: boolean;
    readonly key: string;
    path?: string | null;
    thumbnail?: string | null;
    state?: VideoStateEnum;
    meta?: unknown;
    channel: string;
    upload_by: string;
};

export type VideoAnalytics = {
    impressions: number;
    expands: number;
    clickthroughs: number;
    seeks: number;
    video_name?: string;
    video_key?: string;
    top_annotations: Array<RankedPropertiesById>;
    top_chapters: Array<RankedPropertiesById>;
};

export type VideoRequest = {
    name: string;
    description: string;
    is_deleted?: boolean;
    path?: string | null;
    thumbnail?: string | null;
    state?: VideoStateEnum;
    meta?: unknown;
    channel: string;
    upload_by: string;
};

/**
 * * `encoding` - Encoding
 * * `draft` - Draft
 * * `public` - Public
 * * `private` - Private
 * * `archived` - Archived
 */
export const VideoStateEnum = {
    ENCODING: 'encoding',
    DRAFT: 'draft',
    PUBLIC: 'public',
    PRIVATE: 'private',
    ARCHIVED: 'archived'
} as const;

/**
 * * `encoding` - Encoding
 * * `draft` - Draft
 * * `public` - Public
 * * `private` - Private
 * * `archived` - Archived
 */
export type VideoStateEnum = typeof VideoStateEnum[keyof typeof VideoStateEnum];

export type VideosAnnotationsListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type VideosChaptersListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type VideosCreateError = ({
    attr: 'non_field_errors';
} & VideosCreateNonFieldErrorsErrorComponent) | ({
    attr: 'filename';
} & VideosCreateFilenameErrorComponent);

export type VideosCreateErrorResponse400 = ({
    type: 'validation_error';
} & VideosCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type VideosCreateFilenameErrorComponent = {
    /**
     * * `filename` - filename
     */
    attr: 'filename';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'max_length' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `invalid_context` - invalid_context
     * * `no_channel_id` - no_channel_id
     * * `null` - null
     * * `programming_error` - programming_error
     */
    code: 'invalid' | 'invalid_context' | 'no_channel_id' | 'null' | 'programming_error';
    detail: string;
};

export type VideosCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<VideosCreateError>;
};

export type VideosDestroyErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type VideosDownloadrCreateError = ({
    attr: 'non_field_errors';
} & VideosDownloadrCreateNonFieldErrorsErrorComponent) | ({
    attr: 'url';
} & VideosDownloadrCreateUrlErrorComponent);

export type VideosDownloadrCreateErrorResponse400 = ({
    type: 'validation_error';
} & VideosDownloadrCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type VideosDownloadrCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosDownloadrCreateUrlErrorComponent = {
    /**
     * * `url` - url
     */
    attr: 'url';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosDownloadrCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<VideosDownloadrCreateError>;
};

export type VideosListErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type VideosPartialUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type VideosPartialUpdateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosPartialUpdateError = ({
    attr: 'non_field_errors';
} & VideosPartialUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'name';
} & VideosPartialUpdateNameErrorComponent) | ({
    attr: 'description';
} & VideosPartialUpdateDescriptionErrorComponent) | ({
    attr: 'is_deleted';
} & VideosPartialUpdateIsDeletedErrorComponent) | ({
    attr: 'path';
} & VideosPartialUpdatePathErrorComponent) | ({
    attr: 'thumbnail';
} & VideosPartialUpdateThumbnailErrorComponent) | ({
    attr: 'state';
} & VideosPartialUpdateStateErrorComponent) | ({
    attr: 'meta';
} & VideosPartialUpdateMetaErrorComponent) | ({
    attr: 'channel';
} & VideosPartialUpdateChannelErrorComponent) | ({
    attr: 'upload_by';
} & VideosPartialUpdateUploadByErrorComponent);

export type VideosPartialUpdateErrorResponse400 = ({
    type: 'validation_error';
} & VideosPartialUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type VideosPartialUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosPartialUpdateMetaErrorComponent = {
    /**
     * * `meta` - meta
     */
    attr: 'meta';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosPartialUpdateNameErrorComponent = {
    /**
     * * `name` - name
     */
    attr: 'name';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosPartialUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosPartialUpdatePathErrorComponent = {
    /**
     * * `path` - path
     */
    attr: 'path';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosPartialUpdateStateErrorComponent = {
    /**
     * * `state` - state
     */
    attr: 'state';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     */
    code: 'invalid_choice' | 'null';
    detail: string;
};

export type VideosPartialUpdateThumbnailErrorComponent = {
    /**
     * * `thumbnail` - thumbnail
     */
    attr: 'thumbnail';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosPartialUpdateUploadByErrorComponent = {
    /**
     * * `upload_by` - upload_by
     */
    attr: 'upload_by';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type VideosPartialUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<VideosPartialUpdateError>;
};

export type VideosRetrieveErrorResponse400 = {
    type: 'client_error';
} & ParseErrorResponse;

export type VideosShareCreateAntIdErrorComponent = {
    /**
     * * `ant_id` - ant_id
     */
    attr: 'ant_id';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type VideosShareCreateAtErrorComponent = {
    /**
     * * `at` - at
     */
    attr: 'at';
    /**
     * * `invalid` - invalid
     * * `max_string_length` - max_string_length
     */
    code: 'invalid' | 'max_string_length';
    detail: string;
};

export type VideosShareCreateChapterIdErrorComponent = {
    /**
     * * `chapter_id` - chapter_id
     */
    attr: 'chapter_id';
    /**
     * * `invalid` - invalid
     */
    code: 'invalid';
    detail: string;
};

export type VideosShareCreateEmailFromErrorComponent = {
    /**
     * * `email_from` - email_from
     */
    attr: 'email_from';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosShareCreateEmailToErrorComponent = {
    /**
     * * `email_to` - email_to
     */
    attr: 'email_to';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosShareCreateError = ({
    attr: 'non_field_errors';
} & VideosShareCreateNonFieldErrorsErrorComponent) | ({
    attr: 'email_from';
} & VideosShareCreateEmailFromErrorComponent) | ({
    attr: 'email_to';
} & VideosShareCreateEmailToErrorComponent) | ({
    attr: 'key';
} & VideosShareCreateKeyErrorComponent) | ({
    attr: 'at';
} & VideosShareCreateAtErrorComponent) | ({
    attr: 'chapter_id';
} & VideosShareCreateChapterIdErrorComponent) | ({
    attr: 'ant_id';
} & VideosShareCreateAntIdErrorComponent);

export type VideosShareCreateErrorResponse400 = ({
    type: 'validation_error';
} & VideosShareCreateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type VideosShareCreateKeyErrorComponent = {
    /**
     * * `key` - key
     */
    attr: 'key';
    /**
     * * `blank` - blank
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'blank' | 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosShareCreateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosShareCreateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<VideosShareCreateError>;
};

export type VideosUpdateChannelErrorComponent = {
    /**
     * * `channel` - channel
     */
    attr: 'channel';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type VideosUpdateDescriptionErrorComponent = {
    /**
     * * `description` - description
     */
    attr: 'description';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosUpdateError = ({
    attr: 'non_field_errors';
} & VideosUpdateNonFieldErrorsErrorComponent) | ({
    attr: 'name';
} & VideosUpdateNameErrorComponent) | ({
    attr: 'description';
} & VideosUpdateDescriptionErrorComponent) | ({
    attr: 'is_deleted';
} & VideosUpdateIsDeletedErrorComponent) | ({
    attr: 'path';
} & VideosUpdatePathErrorComponent) | ({
    attr: 'thumbnail';
} & VideosUpdateThumbnailErrorComponent) | ({
    attr: 'state';
} & VideosUpdateStateErrorComponent) | ({
    attr: 'meta';
} & VideosUpdateMetaErrorComponent) | ({
    attr: 'channel';
} & VideosUpdateChannelErrorComponent) | ({
    attr: 'upload_by';
} & VideosUpdateUploadByErrorComponent);

export type VideosUpdateErrorResponse400 = ({
    type: 'validation_error';
} & VideosUpdateValidationError) | ({
    type: 'client_error';
} & ParseErrorResponse);

export type VideosUpdateIsDeletedErrorComponent = {
    /**
     * * `is_deleted` - is_deleted
     */
    attr: 'is_deleted';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosUpdateMetaErrorComponent = {
    /**
     * * `meta` - meta
     */
    attr: 'meta';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosUpdateNameErrorComponent = {
    /**
     * * `name` - name
     */
    attr: 'name';
    /**
     * * `invalid` - invalid
     * * `null` - null
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `required` - required
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'null' | 'null_characters_not_allowed' | 'required' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosUpdateNonFieldErrorsErrorComponent = {
    /**
     * * `non_field_errors` - non_field_errors
     */
    attr: 'non_field_errors';
    /**
     * * `invalid` - invalid
     * * `null` - null
     */
    code: 'invalid' | 'null';
    detail: string;
};

export type VideosUpdatePathErrorComponent = {
    /**
     * * `path` - path
     */
    attr: 'path';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosUpdateStateErrorComponent = {
    /**
     * * `state` - state
     */
    attr: 'state';
    /**
     * * `invalid_choice` - invalid_choice
     * * `null` - null
     */
    code: 'invalid_choice' | 'null';
    detail: string;
};

export type VideosUpdateThumbnailErrorComponent = {
    /**
     * * `thumbnail` - thumbnail
     */
    attr: 'thumbnail';
    /**
     * * `invalid` - invalid
     * * `max_length` - max_length
     * * `null_characters_not_allowed` - null_characters_not_allowed
     * * `surrogate_characters_not_allowed` - surrogate_characters_not_allowed
     */
    code: 'invalid' | 'max_length' | 'null_characters_not_allowed' | 'surrogate_characters_not_allowed';
    detail: string;
};

export type VideosUpdateUploadByErrorComponent = {
    /**
     * * `upload_by` - upload_by
     */
    attr: 'upload_by';
    /**
     * * `does_not_exist` - does_not_exist
     * * `incorrect_type` - incorrect_type
     * * `null` - null
     * * `required` - required
     */
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
};

export type VideosUpdateValidationError = {
    type: ValidationErrorEnum;
    errors: Array<VideosUpdateError>;
};

/**
 * Serializes temporal's workflow info
 */
export type WorkflowInfo = {
    workflow_id: string;
    execution_id: string;
};

export type ApiKeyWritable = {
    name: string;
};

export type AnnotationWritable = {
    title: string;
    description: string;
    meta: AnnotationMeta;
    is_deleted?: boolean;
    kind: KindEnum;
    /**
     * Time in seconds
     */
    starts_at: number;
    /**
     * Time in seconds
     */
    ends_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
};

export type ChannelWritable = {
    name: string;
    is_active?: boolean;
    subscription_plan?: SubscriptionPlanEnum;
    subscription_status?: string | null;
    subscription_expires_at?: Date | null;
    is_paid?: boolean;
    is_free?: boolean;
};

export type ChapterWritable = {
    meta: ChapterMeta;
    is_deleted?: boolean;
    title: string;
    description: string;
    /**
     * Time in seconds
     */
    starts_at: number;
    is_sponsored?: boolean;
    channel: string;
    video: string;
    user: string;
};

/**
 * Serializer for confirming password reset. Signals the Temporal workflow.
 */
export type ConfirmResetRequestWritable = {
    password: string;
    confirm_password: string;
    token: string;
};

export type DubWritable = {
    is_deleted?: boolean;
    elevenlabs_id?: string | null;
    path?: string | null;
    state?: DubStateEnum;
    lang_code: string;
    transcript?: unknown;
    transcript_status?: TranscriptStatusEnum;
    channel: string;
    video: string;
};

/**
 * Serializer for new user onboarding.
 *
 * Creates a user, channel, API key, and initiates the Temporal onboarding workflow.
 */
export type OnboardRequestWritable = {
    email: string;
    username: string;
    password: string;
    confirm_password: string;
};

export type PaginatedCheckoutListWritable = {
    count: number;
    next: string | null;
    previous: string | null;
    results: Array<StripeCheckoutSuccessWritable>;
};

/**
 * Serializer for reading user profile data.
 *
 * Uses explicit fields list to prevent accidental exposure of sensitive data.
 */
export type ProfileReadWritable = {
    [key: string]: unknown;
};

export type RequestDubWritable = {
    key: string;
    lang_code: string;
};

/**
 * Serializes the StripeCheckout model instance.
 */
export type StripeCheckoutWritable = {
    session?: string | null;
    status?: StatusEnum;
    plan?: PlanEnum;
    stripe_invoice_id?: string | null;
    invoice_number?: string | null;
    invoice_status?: string | null;
    invoice_pdf_url?: string | null;
    invoice_hosted_url?: string | null;
    invoice_subtotal?: number | null;
    invoice_tax?: number | null;
    invoice_total?: number | null;
    invoice_amount_paid?: number | null;
    invoice_issued_at?: Date | null;
    invoice_paid_at?: Date | null;
    invoice_period_start?: Date | null;
    invoice_period_end?: Date | null;
    invoice_customer_name?: string | null;
    invoice_customer_email?: string | null;
    channel: string;
};

/**
 * Serializes checkout data for success/thanks pages.
 *
 * Excludes sensitive fields like stripe_price_id from meta.
 * Includes structured invoice data if available.
 */
export type StripeCheckoutSuccessWritable = {
    plan?: PlanEnum;
    status?: StatusEnum;
};

/**
 * Serializer for video upload, creating Video object and returning signed URL.
 */
export type UploadVideoWritable = {
    [key: string]: unknown;
};

/**
 * Serializer for creating and validating username reservations.
 */
export type UsernameReservationRequestWritable = {
    username: string;
    email: string;
    recaptcha_token: string;
};

export type VideoWritable = {
    name: string;
    description: string;
    is_deleted?: boolean;
    path?: string | null;
    thumbnail?: string | null;
    state?: VideoStateEnum;
    meta?: unknown;
    channel: string;
    upload_by: string;
};

export type AccountsApiKeysListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/accounts/api-keys';
};

export type AccountsApiKeysListErrors = {
    400: AccountsApiKeysListErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type AccountsApiKeysListError = AccountsApiKeysListErrors[keyof AccountsApiKeysListErrors];

export type AccountsApiKeysListResponses = {
    200: Array<ApiKey>;
};

export type AccountsApiKeysListResponse = AccountsApiKeysListResponses[keyof AccountsApiKeysListResponses];

export type ChangePasswordData = {
    body: ChangePasswordRequest;
    path?: never;
    query?: never;
    url: '/accounts/change-password';
};

export type ChangePasswordErrors = {
    /**
     * Invalid input data (e.g., incorrect current password, passwords do not match).
     */
    400: unknown;
    /**
     * Authentication credentials were not provided.
     */
    401: unknown;
    500: ErrorResponse500;
};

export type ChangePasswordError = ChangePasswordErrors[keyof ChangePasswordErrors];

export type ChangePasswordResponses = {
    /**
     * Password changed successfully.
     */
    200: Detail;
};

export type ChangePasswordResponse = ChangePasswordResponses[keyof ChangePasswordResponses];

export type AccountsGetTokenCreateData = {
    body: TokenObtainSlidingRequest;
    path?: never;
    query?: never;
    url: '/accounts/get-token';
};

export type AccountsGetTokenCreateErrors = {
    400: AccountsGetTokenCreateErrorResponse400;
    500: ErrorResponse500;
};

export type AccountsGetTokenCreateError2 = AccountsGetTokenCreateErrors[keyof AccountsGetTokenCreateErrors];

export type AccountsGetTokenCreateResponses = {
    200: TokenObtainSliding;
};

export type AccountsGetTokenCreateResponse = AccountsGetTokenCreateResponses[keyof AccountsGetTokenCreateResponses];

export type ProfileRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/accounts/profile';
};

export type ProfileRetrieveErrors = {
    400: ProfileRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type ProfileRetrieveError = ProfileRetrieveErrors[keyof ProfileRetrieveErrors];

export type ProfileRetrieveResponses = {
    /**
     * User profile retrieved successfully.
     */
    200: ProfileRead;
};

export type ProfileRetrieveResponse = ProfileRetrieveResponses[keyof ProfileRetrieveResponses];

export type ProfilePartialUpdateData = {
    body?: PatchedProfileUpdateRequest;
    path?: never;
    query?: never;
    url: '/accounts/profile';
};

export type ProfilePartialUpdateErrors = {
    /**
     * Invalid input data.
     */
    400: unknown;
    /**
     * Authentication credentials were not provided.
     */
    401: unknown;
    500: ErrorResponse500;
};

export type ProfilePartialUpdateError = ProfilePartialUpdateErrors[keyof ProfilePartialUpdateErrors];

export type ProfilePartialUpdateResponses = {
    /**
     * User profile updated successfully.
     */
    200: ProfileRead;
};

export type ProfilePartialUpdateResponse = ProfilePartialUpdateResponses[keyof ProfilePartialUpdateResponses];

export type AccountsRefreshTokenCreateData = {
    body: TokenRefreshSlidingRequest;
    path?: never;
    query?: never;
    url: '/accounts/refresh-token';
};

export type AccountsRefreshTokenCreateErrors = {
    400: AccountsRefreshTokenCreateErrorResponse400;
    500: ErrorResponse500;
};

export type AccountsRefreshTokenCreateError2 = AccountsRefreshTokenCreateErrors[keyof AccountsRefreshTokenCreateErrors];

export type AccountsRefreshTokenCreateResponses = {
    200: TokenRefreshSliding;
};

export type AccountsRefreshTokenCreateResponse = AccountsRefreshTokenCreateResponses[keyof AccountsRefreshTokenCreateResponses];

export type AccountsReserveUsernameCreateData = {
    body: UsernameReservationRequestWritable;
    path?: never;
    query?: never;
    url: '/accounts/reserve-username';
};

export type AccountsReserveUsernameCreateErrors = {
    400: AccountsReserveUsernameCreateErrorResponse400;
    500: ErrorResponse500;
};

export type AccountsReserveUsernameCreateError2 = AccountsReserveUsernameCreateErrors[keyof AccountsReserveUsernameCreateErrors];

export type AccountsReserveUsernameCreateResponses = {
    201: WorkflowInfo;
};

export type AccountsReserveUsernameCreateResponse = AccountsReserveUsernameCreateResponses[keyof AccountsReserveUsernameCreateResponses];

export type AccountsResetPasswordCreateData = {
    body: ResetPasswordSerialzierRequest;
    path?: never;
    query?: never;
    url: '/accounts/reset-password';
};

export type AccountsResetPasswordCreateErrors = {
    400: AccountsResetPasswordCreateErrorResponse400;
    500: ErrorResponse500;
};

export type AccountsResetPasswordCreateError2 = AccountsResetPasswordCreateErrors[keyof AccountsResetPasswordCreateErrors];

export type AccountsResetPasswordCreateResponses = {
    201: WorkflowInfo;
};

export type AccountsResetPasswordCreateResponse = AccountsResetPasswordCreateResponses[keyof AccountsResetPasswordCreateResponses];

export type AccountsResetPasswordConfirmCreateData = {
    body: ConfirmResetRequestWritable;
    path?: never;
    query?: never;
    url: '/accounts/reset-password/confirm';
};

export type AccountsResetPasswordConfirmCreateErrors = {
    400: AccountsResetPasswordConfirmCreateErrorResponse400;
    500: ErrorResponse500;
};

export type AccountsResetPasswordConfirmCreateError2 = AccountsResetPasswordConfirmCreateErrors[keyof AccountsResetPasswordConfirmCreateErrors];

export type AccountsResetPasswordConfirmCreateResponses = {
    201: Detail;
};

export type AccountsResetPasswordConfirmCreateResponse = AccountsResetPasswordConfirmCreateResponses[keyof AccountsResetPasswordConfirmCreateResponses];

export type AnnotationsListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/annotations';
};

export type AnnotationsListErrors = {
    400: AnnotationsListErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type AnnotationsListError = AnnotationsListErrors[keyof AnnotationsListErrors];

export type AnnotationsListResponses = {
    200: Array<Annotation>;
};

export type AnnotationsListResponse = AnnotationsListResponses[keyof AnnotationsListResponses];

export type AnnotationsCreateData = {
    body: AnnotationRequest;
    path?: never;
    query?: never;
    url: '/annotations';
};

export type AnnotationsCreateErrors = {
    400: AnnotationsCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type AnnotationsCreateError2 = AnnotationsCreateErrors[keyof AnnotationsCreateErrors];

export type AnnotationsCreateResponses = {
    201: Annotation;
};

export type AnnotationsCreateResponse = AnnotationsCreateResponses[keyof AnnotationsCreateResponses];

export type AnnotationsDestroyData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this annotation.
         */
        id: string;
    };
    query?: never;
    url: '/annotations/{id}';
};

export type AnnotationsDestroyErrors = {
    400: AnnotationsDestroyErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type AnnotationsDestroyError = AnnotationsDestroyErrors[keyof AnnotationsDestroyErrors];

export type AnnotationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AnnotationsDestroyResponse = AnnotationsDestroyResponses[keyof AnnotationsDestroyResponses];

export type AnnotationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this annotation.
         */
        id: string;
    };
    query?: never;
    url: '/annotations/{id}';
};

export type AnnotationsRetrieveErrors = {
    400: AnnotationsRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type AnnotationsRetrieveError = AnnotationsRetrieveErrors[keyof AnnotationsRetrieveErrors];

export type AnnotationsRetrieveResponses = {
    200: Annotation;
};

export type AnnotationsRetrieveResponse = AnnotationsRetrieveResponses[keyof AnnotationsRetrieveResponses];

export type AnnotationsPartialUpdateData = {
    body?: PatchedAnnotationRequest;
    path: {
        /**
         * A UUID string identifying this annotation.
         */
        id: string;
    };
    query?: never;
    url: '/annotations/{id}';
};

export type AnnotationsPartialUpdateErrors = {
    400: AnnotationsPartialUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type AnnotationsPartialUpdateError2 = AnnotationsPartialUpdateErrors[keyof AnnotationsPartialUpdateErrors];

export type AnnotationsPartialUpdateResponses = {
    200: Annotation;
};

export type AnnotationsPartialUpdateResponse = AnnotationsPartialUpdateResponses[keyof AnnotationsPartialUpdateResponses];

export type AnnotationsUpdateData = {
    body: AnnotationRequest;
    path: {
        /**
         * A UUID string identifying this annotation.
         */
        id: string;
    };
    query?: never;
    url: '/annotations/{id}';
};

export type AnnotationsUpdateErrors = {
    400: AnnotationsUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type AnnotationsUpdateError2 = AnnotationsUpdateErrors[keyof AnnotationsUpdateErrors];

export type AnnotationsUpdateResponses = {
    200: Annotation;
};

export type AnnotationsUpdateResponse = AnnotationsUpdateResponses[keyof AnnotationsUpdateResponses];

export type AssetsCreateData = {
    body: AssetUploadRequest;
    path?: never;
    query?: never;
    url: '/assets';
};

export type AssetsCreateErrors = {
    400: AssetsCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type AssetsCreateError2 = AssetsCreateErrors[keyof AssetsCreateErrors];

export type AssetsCreateResponses = {
    201: AssetUpload;
};

export type AssetsCreateResponse = AssetsCreateResponses[keyof AssetsCreateResponses];

export type ChaptersListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/chapters';
};

export type ChaptersListErrors = {
    400: ChaptersListErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type ChaptersListError = ChaptersListErrors[keyof ChaptersListErrors];

export type ChaptersListResponses = {
    200: Array<Chapter>;
};

export type ChaptersListResponse = ChaptersListResponses[keyof ChaptersListResponses];

export type ChaptersCreateData = {
    body: CreateChapterRequest;
    path?: never;
    query?: never;
    url: '/chapters';
};

export type ChaptersCreateErrors = {
    400: ChaptersCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type ChaptersCreateError2 = ChaptersCreateErrors[keyof ChaptersCreateErrors];

export type ChaptersCreateResponses = {
    201: Chapter;
};

export type ChaptersCreateResponse = ChaptersCreateResponses[keyof ChaptersCreateResponses];

export type ChaptersDestroyData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this chapter.
         */
        id: string;
    };
    query?: never;
    url: '/chapters/{id}';
};

export type ChaptersDestroyErrors = {
    400: ChaptersDestroyErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type ChaptersDestroyError = ChaptersDestroyErrors[keyof ChaptersDestroyErrors];

export type ChaptersDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ChaptersDestroyResponse = ChaptersDestroyResponses[keyof ChaptersDestroyResponses];

export type ChaptersRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this chapter.
         */
        id: string;
    };
    query?: never;
    url: '/chapters/{id}';
};

export type ChaptersRetrieveErrors = {
    400: ChaptersRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type ChaptersRetrieveError = ChaptersRetrieveErrors[keyof ChaptersRetrieveErrors];

export type ChaptersRetrieveResponses = {
    200: Chapter;
};

export type ChaptersRetrieveResponse = ChaptersRetrieveResponses[keyof ChaptersRetrieveResponses];

export type ChaptersPartialUpdateData = {
    body?: PatchedChapterRequest;
    path: {
        /**
         * A UUID string identifying this chapter.
         */
        id: string;
    };
    query?: never;
    url: '/chapters/{id}';
};

export type ChaptersPartialUpdateErrors = {
    400: ChaptersPartialUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type ChaptersPartialUpdateError2 = ChaptersPartialUpdateErrors[keyof ChaptersPartialUpdateErrors];

export type ChaptersPartialUpdateResponses = {
    200: Chapter;
};

export type ChaptersPartialUpdateResponse = ChaptersPartialUpdateResponses[keyof ChaptersPartialUpdateResponses];

export type ChaptersUpdateData = {
    body: ChapterRequest;
    path: {
        /**
         * A UUID string identifying this chapter.
         */
        id: string;
    };
    query?: never;
    url: '/chapters/{id}';
};

export type ChaptersUpdateErrors = {
    400: ChaptersUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type ChaptersUpdateError2 = ChaptersUpdateErrors[keyof ChaptersUpdateErrors];

export type ChaptersUpdateResponses = {
    200: Chapter;
};

export type ChaptersUpdateResponse = ChaptersUpdateResponses[keyof ChaptersUpdateResponses];

export type CheckoutsCreateData = {
    body: CreateCheckoutRequest;
    path?: never;
    query?: never;
    url: '/checkouts';
};

export type CheckoutsCreateErrors = {
    400: CheckoutsCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type CheckoutsCreateError2 = CheckoutsCreateErrors[keyof CheckoutsCreateErrors];

export type CheckoutsCreateResponses = {
    201: StripeCheckout;
};

export type CheckoutsCreateResponse = CheckoutsCreateResponses[keyof CheckoutsCreateResponses];

export type CheckoutsCancelRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/checkouts/{id}/cancel';
};

export type CheckoutsCancelRetrieveErrors = {
    400: CheckoutsCancelRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type CheckoutsCancelRetrieveError = CheckoutsCancelRetrieveErrors[keyof CheckoutsCancelRetrieveErrors];

export type CheckoutsCancelRetrieveResponses = {
    200: Detail;
};

export type CheckoutsCancelRetrieveResponse = CheckoutsCancelRetrieveResponses[keyof CheckoutsCancelRetrieveResponses];

export type CheckoutsInvoiceRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/checkouts/{id}/invoice';
};

export type CheckoutsInvoiceRetrieveErrors = {
    400: CheckoutsInvoiceRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type CheckoutsInvoiceRetrieveError = CheckoutsInvoiceRetrieveErrors[keyof CheckoutsInvoiceRetrieveErrors];

export type CheckoutsInvoiceRetrieveResponses = {
    200: StripeCheckoutSuccess;
};

export type CheckoutsInvoiceRetrieveResponse = CheckoutsInvoiceRetrieveResponses[keyof CheckoutsInvoiceRetrieveResponses];

export type CheckoutsSuccessRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/checkouts/{id}/success';
};

export type CheckoutsSuccessRetrieveErrors = {
    400: CheckoutsSuccessRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type CheckoutsSuccessRetrieveError = CheckoutsSuccessRetrieveErrors[keyof CheckoutsSuccessRetrieveErrors];

export type CheckoutsSuccessRetrieveResponses = {
    200: StripeCheckoutSuccess;
};

export type CheckoutsSuccessRetrieveResponse = CheckoutsSuccessRetrieveResponses[keyof CheckoutsSuccessRetrieveResponses];

export type CheckoutsThanksRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/checkouts/{id}/thanks';
};

export type CheckoutsThanksRetrieveErrors = {
    400: CheckoutsThanksRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type CheckoutsThanksRetrieveError = CheckoutsThanksRetrieveErrors[keyof CheckoutsThanksRetrieveErrors];

export type CheckoutsThanksRetrieveResponses = {
    200: StripeCheckoutSuccess;
};

export type CheckoutsThanksRetrieveResponse = CheckoutsThanksRetrieveResponses[keyof CheckoutsThanksRetrieveResponses];

export type CheckoutsChannelsRetrieveData = {
    body?: never;
    path: {
        channel_id: string;
    };
    query?: never;
    url: '/checkouts/channels/{channel_id}';
};

export type CheckoutsChannelsRetrieveErrors = {
    400: CheckoutsChannelsRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type CheckoutsChannelsRetrieveError = CheckoutsChannelsRetrieveErrors[keyof CheckoutsChannelsRetrieveErrors];

export type CheckoutsChannelsRetrieveResponses = {
    /**
     * Paginated list of checkouts
     */
    200: PaginatedCheckoutList;
};

export type CheckoutsChannelsRetrieveResponse = CheckoutsChannelsRetrieveResponses[keyof CheckoutsChannelsRetrieveResponses];

export type DubsListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dubs';
};

export type DubsListErrors = {
    400: DubsListErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type DubsListError = DubsListErrors[keyof DubsListErrors];

export type DubsListResponses = {
    200: Array<Dub>;
};

export type DubsListResponse = DubsListResponses[keyof DubsListResponses];

export type DubsCreateData = {
    body: RequestDubRequest;
    path?: never;
    query?: never;
    url: '/dubs';
};

export type DubsCreateErrors = {
    400: DubsCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type DubsCreateError2 = DubsCreateErrors[keyof DubsCreateErrors];

export type DubsCreateResponses = {
    201: RequestDub;
};

export type DubsCreateResponse = DubsCreateResponses[keyof DubsCreateResponses];

export type DubsDestroyData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this dub.
         */
        id: string;
    };
    query?: never;
    url: '/dubs/{id}';
};

export type DubsDestroyErrors = {
    400: DubsDestroyErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type DubsDestroyError = DubsDestroyErrors[keyof DubsDestroyErrors];

export type DubsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type DubsDestroyResponse = DubsDestroyResponses[keyof DubsDestroyResponses];

export type DubsRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this dub.
         */
        id: string;
    };
    query?: never;
    url: '/dubs/{id}';
};

export type DubsRetrieveErrors = {
    400: DubsRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type DubsRetrieveError = DubsRetrieveErrors[keyof DubsRetrieveErrors];

export type DubsRetrieveResponses = {
    200: Dub;
};

export type DubsRetrieveResponse = DubsRetrieveResponses[keyof DubsRetrieveResponses];

export type DubsPartialUpdateData = {
    body?: PatchedDubRequest;
    path: {
        /**
         * A UUID string identifying this dub.
         */
        id: string;
    };
    query?: never;
    url: '/dubs/{id}';
};

export type DubsPartialUpdateErrors = {
    400: DubsPartialUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type DubsPartialUpdateError2 = DubsPartialUpdateErrors[keyof DubsPartialUpdateErrors];

export type DubsPartialUpdateResponses = {
    200: Dub;
};

export type DubsPartialUpdateResponse = DubsPartialUpdateResponses[keyof DubsPartialUpdateResponses];

export type DubsUpdateData = {
    body: DubRequest;
    path: {
        /**
         * A UUID string identifying this dub.
         */
        id: string;
    };
    query?: never;
    url: '/dubs/{id}';
};

export type DubsUpdateErrors = {
    400: DubsUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type DubsUpdateError2 = DubsUpdateErrors[keyof DubsUpdateErrors];

export type DubsUpdateResponses = {
    200: Dub;
};

export type DubsUpdateResponse = DubsUpdateResponses[keyof DubsUpdateResponses];

export type LinkParseLinkRetrieveData = {
    body?: never;
    path?: never;
    query: {
        /**
         * The URL to parse and extract metadata from
         */
        url: string;
    };
    url: '/link/parse-link/';
};

export type LinkParseLinkRetrieveErrors = {
    400: LinkParseLinkRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type LinkParseLinkRetrieveError = LinkParseLinkRetrieveErrors[keyof LinkParseLinkRetrieveErrors];

export type LinkParseLinkRetrieveResponses = {
    200: ParseLink;
};

export type LinkParseLinkRetrieveResponse = LinkParseLinkRetrieveResponses[keyof LinkParseLinkRetrieveResponses];

export type OnboardCreateData = {
    body: OnboardRequestWritable;
    path?: never;
    query?: never;
    url: '/onboard';
};

export type OnboardCreateErrors = {
    400: OnboardCreateErrorResponse400;
    500: ErrorResponse500;
};

export type OnboardCreateError2 = OnboardCreateErrors[keyof OnboardCreateErrors];

export type OnboardCreateResponses = {
    201: WorkflowInfo;
};

export type OnboardCreateResponse = OnboardCreateResponses[keyof OnboardCreateResponses];

export type OnboardVerifyRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        channel_id: string;
        user_id: string;
    };
    url: '/onboard/{id}/verify';
};

export type OnboardVerifyRetrieveErrors = {
    400: OnboardVerifyRetrieveErrorResponse400;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type OnboardVerifyRetrieveError = OnboardVerifyRetrieveErrors[keyof OnboardVerifyRetrieveErrors];

export type OnboardVerifyRetrieveResponses = {
    200: Detail;
};

export type OnboardVerifyRetrieveResponse = OnboardVerifyRetrieveResponses[keyof OnboardVerifyRetrieveResponses];

export type ProductsAmazonSearchRetrieveData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Search keyword for Amazon products
         */
        keyword: string;
    };
    url: '/products/amazon-search/';
};

export type ProductsAmazonSearchRetrieveErrors = {
    400: ProductsAmazonSearchRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type ProductsAmazonSearchRetrieveError = ProductsAmazonSearchRetrieveErrors[keyof ProductsAmazonSearchRetrieveErrors];

export type ProductsAmazonSearchRetrieveResponses = {
    200: AmazonSearch;
};

export type ProductsAmazonSearchRetrieveResponse = ProductsAmazonSearchRetrieveResponses[keyof ProductsAmazonSearchRetrieveResponses];

export type PulseListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        timestamp__gte?: Date;
        timestamp__lte?: Date;
    };
    url: '/pulse';
};

export type PulseListErrors = {
    400: PulseListErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type PulseListError2 = PulseListErrors[keyof PulseListErrors];

export type PulseListResponses = {
    200: PaginatedEventList;
};

export type PulseListResponse = PulseListResponses[keyof PulseListResponses];

export type PulseRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this event.
         */
        id: string;
    };
    query?: never;
    url: '/pulse/{id}';
};

export type PulseRetrieveErrors = {
    400: PulseRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type PulseRetrieveError = PulseRetrieveErrors[keyof PulseRetrieveErrors];

export type PulseRetrieveResponses = {
    200: Event;
};

export type PulseRetrieveResponse = PulseRetrieveResponses[keyof PulseRetrieveResponses];

export type PulseAnnotationAnalyticsRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/pulse/annotation_analytics';
};

export type PulseAnnotationAnalyticsRetrieveErrors = {
    400: PulseAnnotationAnalyticsRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type PulseAnnotationAnalyticsRetrieveError = PulseAnnotationAnalyticsRetrieveErrors[keyof PulseAnnotationAnalyticsRetrieveErrors];

export type PulseAnnotationAnalyticsRetrieveResponses = {
    200: Event;
};

export type PulseAnnotationAnalyticsRetrieveResponse = PulseAnnotationAnalyticsRetrieveResponses[keyof PulseAnnotationAnalyticsRetrieveResponses];

export type PulseAnnotationsRetrieveData = {
    body?: never;
    path?: never;
    query: {
        timestamp__gte: Date;
        timestamp__lte?: Date;
    };
    url: '/pulse/annotations';
};

export type PulseAnnotationsRetrieveErrors = {
    400: PulseAnnotationsRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type PulseAnnotationsRetrieveError2 = PulseAnnotationsRetrieveErrors[keyof PulseAnnotationsRetrieveErrors];

export type PulseAnnotationsRetrieveResponses = {
    200: AnnotationMetrics;
};

export type PulseAnnotationsRetrieveResponse = PulseAnnotationsRetrieveResponses[keyof PulseAnnotationsRetrieveResponses];

export type PulseChapterAnalyticsRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/pulse/chapter_analytics';
};

export type PulseChapterAnalyticsRetrieveErrors = {
    400: PulseChapterAnalyticsRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type PulseChapterAnalyticsRetrieveError = PulseChapterAnalyticsRetrieveErrors[keyof PulseChapterAnalyticsRetrieveErrors];

export type PulseChapterAnalyticsRetrieveResponses = {
    200: Event;
};

export type PulseChapterAnalyticsRetrieveResponse = PulseChapterAnalyticsRetrieveResponses[keyof PulseChapterAnalyticsRetrieveResponses];

export type PulseChaptersRetrieveData = {
    body?: never;
    path?: never;
    query: {
        timestamp__gte: Date;
        timestamp__lte?: Date;
    };
    url: '/pulse/chapters';
};

export type PulseChaptersRetrieveErrors = {
    400: PulseChaptersRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type PulseChaptersRetrieveError2 = PulseChaptersRetrieveErrors[keyof PulseChaptersRetrieveErrors];

export type PulseChaptersRetrieveResponses = {
    200: ChapterMetrics;
};

export type PulseChaptersRetrieveResponse = PulseChaptersRetrieveResponses[keyof PulseChaptersRetrieveResponses];

export type PulseInsightsRetrieveData = {
    body?: never;
    path?: never;
    query: {
        kind: string;
        name: string;
        timestamp__gte: Date;
        timestamp__lte?: Date;
    };
    url: '/pulse/insights';
};

export type PulseInsightsRetrieveErrors = {
    400: PulseInsightsRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type PulseInsightsRetrieveError2 = PulseInsightsRetrieveErrors[keyof PulseInsightsRetrieveErrors];

export type PulseInsightsRetrieveResponses = {
    200: Insights;
};

export type PulseInsightsRetrieveResponse = PulseInsightsRetrieveResponses[keyof PulseInsightsRetrieveResponses];

export type PulseSummaryRetrieveData = {
    body?: never;
    path?: never;
    query: {
        timestamp__gte: Date;
        timestamp__lte?: Date;
    };
    url: '/pulse/summary';
};

export type PulseSummaryRetrieveErrors = {
    400: PulseSummaryRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type PulseSummaryRetrieveError2 = PulseSummaryRetrieveErrors[keyof PulseSummaryRetrieveErrors];

export type PulseSummaryRetrieveResponses = {
    200: PulseSummary;
};

export type PulseSummaryRetrieveResponse = PulseSummaryRetrieveResponses[keyof PulseSummaryRetrieveResponses];

export type PulseVideoAnalyticsRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        timestamp__gte?: Date;
        timestamp__lte?: Date;
    };
    url: '/pulse/video_analytics';
};

export type PulseVideoAnalyticsRetrieveErrors = {
    400: PulseVideoAnalyticsRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type PulseVideoAnalyticsRetrieveError2 = PulseVideoAnalyticsRetrieveErrors[keyof PulseVideoAnalyticsRetrieveErrors];

export type PulseVideoAnalyticsRetrieveResponses = {
    200: VideoAnalytics;
};

export type PulseVideoAnalyticsRetrieveResponse = PulseVideoAnalyticsRetrieveResponses[keyof PulseVideoAnalyticsRetrieveResponses];

export type SchemaRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        format?: 'json' | 'yaml';
        lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant';
    };
    url: '/schema';
};

export type SchemaRetrieveErrors = {
    400: SchemaRetrieveErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type SchemaRetrieveError = SchemaRetrieveErrors[keyof SchemaRetrieveErrors];

export type SchemaRetrieveResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type SchemaRetrieveResponse = SchemaRetrieveResponses[keyof SchemaRetrieveResponses];

export type VideosListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/videos';
};

export type VideosListErrors = {
    400: VideosListErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type VideosListError = VideosListErrors[keyof VideosListErrors];

export type VideosListResponses = {
    200: Array<Video>;
};

export type VideosListResponse = VideosListResponses[keyof VideosListResponses];

export type VideosCreateData = {
    body: UploadVideoRequest;
    path?: never;
    query?: never;
    url: '/videos';
};

export type VideosCreateErrors = {
    400: VideosCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type VideosCreateError2 = VideosCreateErrors[keyof VideosCreateErrors];

export type VideosCreateResponses = {
    201: UploadVideo;
};

export type VideosCreateResponse = VideosCreateResponses[keyof VideosCreateResponses];

export type VideosDestroyData = {
    body?: never;
    path: {
        key: string;
    };
    query?: never;
    url: '/videos/{key}';
};

export type VideosDestroyErrors = {
    400: VideosDestroyErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type VideosDestroyError = VideosDestroyErrors[keyof VideosDestroyErrors];

export type VideosDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type VideosDestroyResponse = VideosDestroyResponses[keyof VideosDestroyResponses];

export type VideosRetrieveData = {
    body?: never;
    path: {
        key: string;
    };
    query?: never;
    url: '/videos/{key}';
};

export type VideosRetrieveErrors = {
    400: VideosRetrieveErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type VideosRetrieveError = VideosRetrieveErrors[keyof VideosRetrieveErrors];

export type VideosRetrieveResponses = {
    200: Video;
};

export type VideosRetrieveResponse = VideosRetrieveResponses[keyof VideosRetrieveResponses];

export type VideosPartialUpdateData = {
    body?: PatchedVideoRequest;
    path: {
        key: string;
    };
    query?: never;
    url: '/videos/{key}';
};

export type VideosPartialUpdateErrors = {
    400: VideosPartialUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type VideosPartialUpdateError2 = VideosPartialUpdateErrors[keyof VideosPartialUpdateErrors];

export type VideosPartialUpdateResponses = {
    200: Video;
};

export type VideosPartialUpdateResponse = VideosPartialUpdateResponses[keyof VideosPartialUpdateResponses];

export type VideosUpdateData = {
    body: VideoRequest;
    path: {
        key: string;
    };
    query?: never;
    url: '/videos/{key}';
};

export type VideosUpdateErrors = {
    400: VideosUpdateErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type VideosUpdateError2 = VideosUpdateErrors[keyof VideosUpdateErrors];

export type VideosUpdateResponses = {
    200: Video;
};

export type VideosUpdateResponse = VideosUpdateResponses[keyof VideosUpdateResponses];

export type VideosAnnotationsListData = {
    body?: never;
    path: {
        key: string;
    };
    query?: never;
    url: '/videos/{key}/annotations';
};

export type VideosAnnotationsListErrors = {
    400: VideosAnnotationsListErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type VideosAnnotationsListError = VideosAnnotationsListErrors[keyof VideosAnnotationsListErrors];

export type VideosAnnotationsListResponses = {
    200: Array<Annotation>;
};

export type VideosAnnotationsListResponse = VideosAnnotationsListResponses[keyof VideosAnnotationsListResponses];

export type VideosChaptersListData = {
    body?: never;
    path: {
        key: string;
    };
    query?: never;
    url: '/videos/{key}/chapters';
};

export type VideosChaptersListErrors = {
    400: VideosChaptersListErrorResponse400;
    401: ErrorResponse401;
    404: ErrorResponse404;
    500: ErrorResponse500;
};

export type VideosChaptersListError = VideosChaptersListErrors[keyof VideosChaptersListErrors];

export type VideosChaptersListResponses = {
    200: Array<Chapter>;
};

export type VideosChaptersListResponse = VideosChaptersListResponses[keyof VideosChaptersListResponses];

export type VideosDownloadrCreateData = {
    body: DownloadrRequest;
    path?: never;
    query?: never;
    url: '/videos/downloadr';
};

export type VideosDownloadrCreateErrors = {
    400: VideosDownloadrCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type VideosDownloadrCreateError2 = VideosDownloadrCreateErrors[keyof VideosDownloadrCreateErrors];

export type VideosDownloadrCreateResponses = {
    201: WorkflowInfo;
};

export type VideosDownloadrCreateResponse = VideosDownloadrCreateResponses[keyof VideosDownloadrCreateResponses];

export type VideosShareCreateData = {
    body: ShareVideoRequest;
    path?: never;
    query?: never;
    url: '/videos/share';
};

export type VideosShareCreateErrors = {
    400: VideosShareCreateErrorResponse400;
    401: ErrorResponse401;
    500: ErrorResponse500;
};

export type VideosShareCreateError2 = VideosShareCreateErrors[keyof VideosShareCreateErrors];

export type VideosShareCreateResponses = {
    201: WorkflowInfo;
};

export type VideosShareCreateResponse = VideosShareCreateResponses[keyof VideosShareCreateResponses];
